{
  "notificationTitle": "Уведомление",
  "serverError": "Ошибка сервера. Пожалуйста, попробуйте позже.",
  "MALE": "мужчина",
  "FEMALE": "женский",
  "GEL": "Лари",
  "NAV": {
    "APPLICATIONS": "Меню",
    "DASHBOARDS": "Главная",
    "user-sources": "Источники пользователей",
    "CASHIER": "Касса",
    "EXPENCE": "Расходы",
    "add_expences": "обработка выхода",
    "administration": "Администрирование",
    "organizations": "Организации",
    "HR": "HR",
    "users": "Работники",
    "salary": "зарплата",
    "scheduleOverview": "Обзор графика",
    "services": "Процедуры",
    "customers": "Пользователи",
    "customer_duplicates": "Повторяющиеся номера",
    "calendars": "Календарь",
    "calendars_daily": "дневная форма",
    "calendars_room": "дневная форма(room)",
    "calendars_canceled": "записи",
    "online_booking": "онлайн бронирование",
    "stats": "Статистика",
    "stats_detailed": "подробный поиск",
    "profit_loss": "прибыль-убыток",
    "graphs": "графические диаграммы",
    "transactions": "Транзакции",
    "transaction_history": "история транзакций",
    "transaction_deleted": "удаленные транзакции",
    "communication": "Связь ",
    "communication_sms": "Связь",
    "communication_history": " история сообщений",
    "operations": "операции ",
    "consignations": "консигнации",
    "expense_categories": "категорий выхода",
    "visitReminder": "напоминание о визите",
    "ehr": "EHR",
    "ehrTemplate": "Шаблоны EHR",
    "erx": "ERX",
    "organization": "Организация",
    "agreement-templates": "Шаблоны соглашений",
    "classification_codes": "Классификационные коды",
    "patients": "Пациенты",
    "invoices": "Счета",
    "rooms": "Кабинеты",
    "booking-sources": "Источники Бронирования",
    "reports": "Отчёты",
    "cash_flow": "Денежный поток",
    "employee_income": "Доход сотрудников",
    "service_analytics": "Аналитика услуг",
    "category_analytics": "Аналитика категорий",
    "client_spending": "Расходы клиентов",
    "bookinghub": "BookingHub",
    "onlineCatalog": "Онлайн каталог",
    "service_packages": "Сервисные пакеты",
    "communication_config": "Конфигурация SMS",
    "birthdayGreetings": "Дни рождения",
    "birthdayConfig": "Настройка дней рождения",
    "productions": "Продукция",
    "products": "Полный список",
    "realizations": "продажа"
  },
  "COLUMNS": {
    "transactionId": "Транс. №",
    "name": "Наименование",
    "branch": "ფილიალი",
    "legalForm": "Правовая форма",
    "legalName": "Юридическое назв.",
    "registrationNumber": "К/И",
    "physicalAddress": "Физ. адрес.",
    "legalAddress": "Юридич. адрес.",
    "director": "Директор",
    "identityNumber": "#идентификаций",
    "mobilePhone": "Номер телефона",
    "phone": "Телефон",
    "facebook": "facebook",
    "information": "Информация",
    "createdAt": "Создан",
    "cardNo": "ბართის #",
    "selectUser": "Изменить клиента",
    "updateUser": "Редактировать клиента",
    "unknownUser": "Неизвестный клиент",
    "firstname": "Имя",
    "lastname": "Фамилия",
    "fullName": "Имя, Фамилия",
    "gender": "Пол",
    "birthDate": "Дата рождения",
    "position": "Позиция",
    "productCategory": "Категория",
    "serviceCategory": "Категория",
    "distributor": "Доставщик",
    "quantity": "Количество",
    "sum": "Сумма",
    "grSum": "Сумма (граммы)",
    "grPerItem": "Граммы (в количестве)",
    "pricePerItem": "Доступная цена",
    "avgPricePerItem": "Доступная цена(средняя)",
    "salePricePerItem": "Цена продажи",
    "buyDate": "Дата приобретения",
    "updateDate": "Дата обновления",
    "transactionType": "Тип транзакций",
    "employee": "Сотрудник",
    "user": "Пользователь",
    "service": "Сервис",
    "priceSum": "Оплачено",
    "cash": "Наличными",
    "card": "Картой",
    "price": "Стоимость",
    "bookingDate": "Дата записи",
    "startTime": "Время начала",
    "endTime": "Время окончания",
    "salePrice": "Цена со скидкой",
    "salePercent": "% скидки",
    "fixedPrice": "Фиксированная л",
    "fixedPercent": "Фиксированный %",
    "fixedSpend": "Фиксированные затраты",
    "additionalExpense": "Дополнительные затраты",
    "barcode": "Баркод",
    "productName": "Название продукта",
    "productVolume": "Обьем продукта",
    "peymentType": "Тип оплаты",
    "createdBy": "Кто создал",
    "status": "Статус",
    "unitGram": "Обьем",
    "unitQuantity": "Количество",
    "minutes": "Минуты",
    "balance": "ბალანსი(₾)",
    "employeePercent": "% сотрудника",
    "employeeSalary": "зарплата сотрудника",
    "employeFixedPrice": "фиксированная сумма",
    "specFixedSpend": "Затраты на специальную процедуру",
    "time": "Время",
    "isSpecial": "Специальный",
    "autoPriceView": "Цена автоматически",
    "autoTimeView": "Время автоматически",
    "color": "Цвет",
    "category": "Категория",
    "room": "Комната",
    "whStart": "Время начала",
    "whEnd": "Время окончания",
    "description": "Описание",
    "comment": "комментарий",
    "expenceCategory": "категория расходов",
    "username": "пользователь",
    "date": "дата",
    "openSum": "открытая сумма",
    "addMoney": "добавить деньги",
    "income": "доход",
    "incomeCash": "доход наличными",
    "incomeCard": "доход картой",
    "incomeBank": "доход банком",
    "outcome": "расход",
    "outcomeCash": "расход наличными",
    "outcomeCard": "расход картой",
    "outcomeBank": "расход банком",
    "expense": "расход",
    "closeSum": "закрытая сумма",
    "salarySum": "зарплата",
    "expenceSum": "расходы",
    "profit": "прибыль",
    "profit_expense": "მოგება - ფიქს. ხარჯი",
    "insurance": "პროვაიდერი",
    "contactPerson": "Контактное лицо",
    "contactPhone": "Контактный телефон",
    "contactMobile": "Контактный мобильный",
    "OperationNumber": "#",
    "operationType": "Тип операции",
    "operationSource": "Источник операции",
    "operationDate": "Дата операции",
    "bestBefore": "Срок годности",
    "avgPrice": "Средняя цена",
    "isSpend": "Расход",
    "senderName": "Имя отправителя",
    "to": "Кому",
    "eventType": "SMS ტიპი",
    "eventKey": "შეხს. წყარო",
    "schedulePeriod": "შეხს. პერიოდი",
    "messageTemplate": "შეტყობინება",
    "role": "როლი",
    "bankTransfer": "Банковский перевод"
  },
  "PAYMENTTYPE": {
    "1": "Наличный расчет",
    "2": "Банковская карточка",
    "3": "Наличный + банковский",
    "4": "Минуты",
    "5": "Баланс",
    "6": "Бартер",
    "7": "консигнация",
    "8": "Банковский перевод",
    "9": "Наличные",
    "10": "Карта",
    "11": "Без оплаты",
    "12": "Онлайн (BookingHub)"
  },
  "TRANSACTIONTYPE": {
    "SELL": "Продажа",
    "SPEND": "Растраты",
    "EVENT": "Запись",
    "SALARY": "Зарплата",
    "REALIZATION": "Реализация",
    "EXPENCE": "Расходы",
    "BUY": "Приобретение",
    "BALANCEIN": "Пополнение баланса",
    "BALANCEOUT": "Списание с баланса",
    "BALANCERETURN": "Возврат с баланса",
    "CONSIGNATION": "Консигнация",
    "CASHIER": "Добавление денег",
    "CASHIER_OUT": "Списание денег"
  },
  "OPERATION_TYPE": {
    "SELL": "Продажа",
    "SPEND": "Растраты",
    "EVENT": "Запись",
    "EVENT_SPEC": "Спец. процедура",
    "SALARY": "Зарплата",
    "SALARY_OUT": "Зарплата сотрудника",
    "REALIZATION": "Реализация",
    "EXPENCE": "Расходы",
    "BUY": "Приобретение",
    "BALANCEIN": "Пополнение баланса",
    "BALANCEOUT": "Списание с баланса",
    "BALANCERETURN": "Возврат с баланса",
    "CASHIER_ADD": "Добавление денег",
    "CASHIER_OUT": "Списание денег",
    "CONSIGNATION_PAY": "Покрытие консигнаций",
    "PACKAGE_ITEM": "Услуга пакета"
  },
  "OPERATION_SOURCE": {
    "NONE": "N/A",
    "BOOKING": "Запись",
    "SALARY": "Зарплата",
    "REALIZATION": "Реализация",
    "EXPENCE": "Расходы",
    "BUY": "Приобретение",
    "PURCHASE": "Приобретение",
    "BALANCEIN": "Пополнение баланса",
    "BALANCE": "Баланс",
    "BALANCERETURN": "Возврат с баланса",
    "CASHIER": "Касса",
    "SERVICE_PACKAGE": "Пакет услуг"
  },
  "operation": {
    "detailsByBank": "Детали по банку",
    "noBankInfo": "Нет информации по банку",
    "editComment": "Редактировать комментарий",
    "commentHistory": "История комментария",
    "noCommentEdits": "Изменений нет",
    "editedBy": "Изменил: {{name}}",
    "editCommentFailed": "Не удалось сохранить комментарий"
  },
  "PAGINATION": {
    "page": "Страница",
    "pageCount": "Всего"
  },
  "CASHIER": {
    "date": "Дата",
    "yesNo": "Вы уверены, что хотите завершить день?",
    "start": "начало",
    "finish": "Заканчивание",
    "update": "Обновление",
    "edit": "Редактировать",
    "page": "страница",
    "openingDay": " Открытие дня",
    "addCash": "Добавляйте Сумму",
    "addSum": " Сумма",
    "comment": "Комментарий",
    "reOpen": "Переоткрыть",
    "reOpenConfirm": "Вы уверены, что хотите переоткрыть день?",
    "need_open": "Необходимо открыть день",
    "operationType": "Тип операции",
    "statistic": {
      "edit": "Изменение открытия кассы",
      "addCash": "Добавляйте Сумму",
      "openSum": "Сумма при открытии дня",
      "close": "Закрытие кассы",
      "open": "Открытие кассы",
      "income": "Доход",
      "expense": "Фиксированный расход",
      "additionalExpense": "Дополнительный расход",
      "outcome": "Расходы",
      "currentSum": "Текущая сумма"
    },
    "COLUMNS": {
      "date": "Дата",
      "openSum": "при открытии",
      "addMoney": "добавлен",
      "income": "Доход",
      "incomeCash": "наличные",
      "incomeCard": "Безналичный",
      "incomeBank": "Банковский",
      "outcome": "Расходы",
      "outcomeBank": "Расх. Банковский",
      "outcomeCash": "Расх. Наличные",
      "outcomeCard": "Расх. Безналичный",
      "expense": "Расход на продукты",
      "additionalExpense": "Дополнительный расход",
      "closeSum": "При закрытии",
      "createdBy": "Кто открыл",
      "comment": "Комментарий",
      "openedAt": "Дата открытия",
      "closedAt": "Дата закрытия",
      "closedBy": "Кто закрыл"
    },
    "advanced": {
      "currentTab": "Текущая касса",
      "historyTab": "Прошедшие кассы",
      "transactions": "Транзакции",
      "noBank": "Без банка",
      "refresh": "Обновить",
      "export": "Экспорт",
      "retry": "Повторить",
      "loadFailed": "Не удалось загрузить данные",
      "exportFailed": "Не удалось выполнить экспорт",
      "reopen": "Открыть заново",
      "reopenConfirm": "Вы уверены, что хотите заново открыть эту кассу?",
      "clearFilter": "Очистить фильтр",
      "time": "Время",
      "type": "Тип",
      "method": "Способ оплаты",
      "bank": "Банк",
      "amount": "Сумма",
      "total": "Итого",
      "date": "Дата",
      "cash": "Наличные",
      "card": "Карта",
      "cashInDrawer": "Наличные в кассе",
      "addMoney": "Добавить деньги",
      "subMoney": "Изъять деньги",
      "closeDay": "Закрыть день",
      "bankTransfer": "Банковский перевод",
      "openedAt": "Время открытия",
      "openedBy": "Открыл",
      "tour": {
        "next": "Далее",
        "prev": "Назад",
        "done": "Готово",
        "progress": "{{current}} / {{total}}",
        "tabsTitle": "Две вкладки",
        "tabsBody": "«Текущая касса» — касса за сегодня. «Кассы прошлых дней» — история закрытых дней.",
        "daySummaryTitle": "Итоги дня",
        "daySummaryBody": "Одна карточка показывает состояние кассы: остаток, приход и расход.",
        "actionsTitle": "Быстрые действия",
        "actionsBody": "Внесение, изъятие денег и другие действия. Наведите курсор на значок, чтобы увидеть название.",
        "dayStateTitle": "Открытие и закрытие дня",
        "dayStateBody": "Этой кнопкой открывается и закрывается кассовый день.",
        "banksTitle": "По банкам",
        "banksBody": "Нажмите на банк — ниже останутся только его транзакции.",
        "bannerTitle": "Переключение версии",
        "bannerBody": "До 26 октября здесь можно вернуться к старой версии или снова пройти этот обзор.",
        "learnMore": "Подробный обзор",
        "sectionHelpTitle": "Подробные обзоры",
        "sectionHelpBody": "У каждого раздела есть кнопка ?. Нажмите её, чтобы подробно разобрать этот раздел: карточки, действия, транзакции и закрытые дни.",
        "sections": {
          "summary": {
            "openCardTitle": "Начальный остаток",
            "openCardBody": "Сумма в кассе на момент открытия дня.",
            "openMovesTitle": "Внесено и изъято",
            "openMovesBody": "Зелёным — деньги, внесённые за день, красным — изъятые. Справа — дата кассового дня.",
            "openedByTitle": "Кто открыл",
            "openedByBody": "Когда открыт день и какой сотрудник открыл кассу.",
            "incomeCardTitle": "Приход",
            "incomeCardBody": "Общий приход за день по всем способам оплаты.",
            "incomeMethodsTitle": "Способы оплаты",
            "incomeMethodsBody": "Приход по способам: наличные, карта, банковский перевод. Под картой и переводом видно, сколько пришло через каждый банк.",
            "incomeExpensesTitle": "Расходы",
            "incomeExpensesBody": "Расход на продукцию, дополнительный расход и их сумма.",
            "incomeBanksTitle": "Приход по банкам",
            "incomeBanksBody": "Приход по карте и переводу в разбивке по банкам. Нажмите на банк — ниже останутся только его транзакции.",
            "outcomeCardTitle": "Расход",
            "outcomeCardBody": "Общий расход за день.",
            "outcomeMethodsTitle": "Способы расхода",
            "outcomeMethodsBody": "Расход по способам: наличные, карта, банковский перевод; под картой и переводом — суммы по банкам.",
            "outcomeBanksTitle": "Расход по банкам",
            "outcomeBanksBody": "Нажмите на банк — ниже останутся только его транзакции.",
            "currentCardTitle": "Текущий остаток",
            "currentCardBody": "Наличные, которые сейчас должны быть в кассе."
          },
          "actions": {
            "addTitle": "Внести деньги",
            "addBody": "Внести наличные в кассу, например для сдачи.",
            "subTitle": "Изъять деньги",
            "subBody": "Изъять наличные из кассы.",
            "editOpenTitle": "Изменить начальный остаток",
            "editOpenBody": "Исправьте начальный остаток дня, если он введён неверно.",
            "refreshTitle": "Обновить",
            "refreshBody": "Заново загрузить данные кассы.",
            "dayStateTitle": "Открытие и закрытие дня",
            "dayStateBody": "Откройте кассу в начале дня и закройте в конце. Только что закрытый день здесь же можно открыть снова."
          },
          "transactions": {
            "filtersTitle": "Фильтры",
            "filtersBody": "Фильтруйте транзакции по типу, способу оплаты и банку.",
            "refreshTitle": "Обновить",
            "refreshBody": "Заново загрузить список транзакций.",
            "exportTitle": "Экспорт",
            "exportBody": "Скачать транзакции в виде файла Excel.",
            "colTimeTitle": "Время",
            "colTimeBody": "Когда прошла транзакция.",
            "colKindTitle": "Тип и способ",
            "colKindBody": "Что это за операция (например, оплата визита, внесение денег) и как оплачено.",
            "colBankTitle": "Как оплачено",
            "colBankBody": "Сумма по способам оплаты: наличные, карта и банковский перевод. Рядом с суммой по карте и переводу указан банк; у наличных банка нет.",
            "colAmountTitle": "Итого",
            "colAmountBody": "Полная сумма транзакции — наличные, карта и банковский перевод вместе."
          },
          "history": {
            "rangeTitle": "Период",
            "rangeBody": "Выберите даты, чтобы увидеть закрытые дни за этот период.",
            "refreshTitle": "Обновить",
            "refreshBody": "Заново загрузить список.",
            "exportTitle": "Экспорт",
            "exportBody": "Скачать закрытые дни в виде файла Excel.",
            "colDateTitle": "Дата",
            "colDateBody": "Кассовый день.",
            "colOpenTitle": "Начальный остаток и движение",
            "colOpenBody": "Начальный остаток дня и деньги, внесённые или изъятые за день.",
            "colIncomeTitle": "Приход",
            "colIncomeBody": "Общий приход и его разбивка: наличные, карта, перевод. В колонках карты и перевода суммы видны и по банкам.",
            "colOutcomeTitle": "Расход",
            "colOutcomeBody": "Общий расход и его разбивка: наличные, карта, перевод, по банкам.",
            "colExpenseTitle": "Расходы",
            "colExpenseBody": "Расход на продукцию и дополнительный расход.",
            "colCloseTitle": "Конечный остаток",
            "colCloseBody": "Наличные, оставшиеся в кассе при закрытии дня.",
            "colPeopleTitle": "Открытие и закрытие",
            "colPeopleBody": "Когда и кто открыл и закрыл кассу.",
            "colCommentTitle": "Комментарий",
            "colCommentBody": "Комментарий, оставленный при закрытии дня.",
            "rowActionsTitle": "Действия",
            "rowActionsBody": "«Обновить» пересчитывает суммы дня. «Редактировать» исправляет начальный остаток."
          }
        }
      }
    },
    "versionSwitch": {
      "oldBanner": "Доступна обновлённая версия кассы. До 26 октября вы можете попробовать её и при желании вернуться к старой версии.",
      "newBanner": "Вы используете обновлённую версию кассы. До 26 октября можно вернуться к старой версии, после этой даты останется только новая.",
      "tryNew": "Перейти на новую версию",
      "backToOld": "Вернуться к старой версии",
      "tour": "Обзор",
      "confirmToNewTitle": "Перейти на новую версию кассы?",
      "confirmToOldTitle": "Вернуться к старой версии кассы?",
      "confirmBody": "Изменение коснётся всех сотрудников филиала. Данные кассы не изменятся.",
      "failed": "Не удалось сменить версию. Попробуйте ещё раз."
    }
  },
  "HR": {
    "employee": {
      "positions": "პოზიციები",
      "employees": "თანამშრომლები"
    }
  },
  "PAYROLL": {
    "title": "Расчёт зарплаты",
    "periods": "Расчётные периоды",
    "year": "Год",
    "period": "Период",
    "status": "Статус",
    "total": "Итого",
    "open": "Открыть",
    "calculate": "Рассчитать",
    "recalculate": "Пересчитать",
    "generateYear": "Создать периоды за {{year}}",
    "generated": "Периоды созданы",
    "back": "К списку периодов",
    "employees": "Сотрудников: {{count}}",
    "finalSalary": "Итоговая зарплата",
    "formerEmployee": "Бывший сотрудник",
    "noLines": "В этом расчёте нет начислений.",
    "noPeriodsTitle": "Нет расчётных периодов за {{year}}",
    "noPeriodsHint": "Создайте их по настроенному циклу.",
    "retry": "Повторить",
    "state": {
      "calculated": "Рассчитан",
      "approved": "Утверждён",
      "ended": "Не рассчитан",
      "inProgress": "Текущий",
      "upcoming": "Предстоящий"
    },
    "kind": {
      "FIXED": "Оклад",
      "COMMISSION": "Процент",
      "ADJUSTMENT": "Премия/штраф",
      "CORRECTION": "Корректировка"
    },
    "recalcConfirm": {
      "title": "Пересчитать этот период?",
      "body": "Текущие суммы будут удалены и заменены.",
      "ok": "Пересчитать",
      "cancel": "Отмена"
    },
    "skipped": {
      "warning": "Пропущено сотрудников: {{count}}",
      "review": "Посмотреть",
      "title": "Пропущенные сотрудники",
      "setRate": "Указать оплату",
      "reason": {
        "NO_RATE_SLICE": "Оплата не настроена",
        "NOT_EMPLOYED_IN_PERIOD": "Не работал в этом периоде"
      }
    },
    "rate": {
      "title": "Указать оплату",
      "fixedSalary": "Оклад (в месяц)",
      "outputPercent": "Процент (от выработки)",
      "effectiveFrom": "Действует с",
      "save": "Сохранить",
      "cancel": "Отмена",
      "saved": "Оплата сохранена",
      "recalculateNow": "Пересчитать сейчас",
      "current": "Текущая оплата: {{fixed}} + {{percent}}%",
      "none": "Оплата не указана",
      "history": {
        "title": "История оплаты",
        "current": "Текущая",
        "previous": "Предыдущая",
        "openEnded": "с {{from}}",
        "closed": "{{from}} → {{to}}",
        "none": "Прежних оплат нет"
      }
    },
    "errors": {
      "notEnabled": "Модуль зарплаты ещё не включён для этого филиала.",
      "forbidden": "У вас нет прав на это действие.",
      "futurePeriod": "Этот период ещё не начался.",
      "runConflict": "Этот период сейчас рассчитывает другой пользователь. Попробуйте через минуту.",
      "runNotFound": "Этот расчёт больше не существует.",
      "periodNotFound": "Этот период больше не существует.",
      "periodBranchMismatch": "Этот период относится к другому филиалу.",
      "rateBackdate": "Дата раньше начала текущей оплаты. Выберите более позднюю дату.",
      "rateTerminateBeforeStart": "Дата окончания раньше начала текущей оплаты.",
      "rateNegative": "Оклад и процент не могут быть отрицательными.",
      "rateRangeInverted": "Дата окончания раньше даты начала.",
      "carryForwardSystemOnly": "Перенесённый остаток создаётся системой и не добавляется вручную.",
      "recurUntilNotAllowed": "Дата окончания возможна только у регулярной премии.",
      "recurUntilBackward": "Дата окончания должна быть позже текущей.",
      "foreignEmployee": "Этот сотрудник не относится к вашей организации.",
      "adjustmentNotFound": "Эта корректировка больше не существует.",
      "equalSplitWeekly": "«Поровну» нельзя использовать с еженедельным циклом.",
      "rangeInverted": "Дата начала позже даты окончания.",
      "runAlreadyApproved": "Этот расчёт уже утверждён.",
      "runNotApproved": "Этот расчёт не утверждён.",
      "runHasPayouts": "По этому расчёту уже проведены выплаты. Чтобы отменить утверждение, сначала удалите их.",
      "nextPeriodMissing": "За сотрудником остался долг, а следующего периода нет. Сначала создайте следующий период.",
      "carryForwardConsumed": "Последующий расчёт уже использовал остаток этого расчёта, отменить утверждение больше нельзя.",
      "employeeNotInRun": "Этого сотрудника нет в расчёте.",
      "lineNotFound": "Этой строки расчёта больше не существует. Обновите расчёт.",
      "payoutExceedsBalance": "Это больше, чем сотруднику ещё причитается.",
      "payoutZero": "Введите сумму.",
      "payoutNotFound": "Этой выплаты больше не существует.",
      "runBranchMismatch": "Этот расчёт относится к другому филиалу.",
      "bankIdRequired": "Выберите банк для перевода.",
      "bankIdNotAllowedForCash": "Для наличных банк не нужен.",
      "duplicateTenderMethod": "Каждый способ оплаты можно указать только один раз на сотрудника.",
      "generic": "Произошла ошибка. Попробуйте ещё раз."
    },
    "pay": {
      "approve": "Утвердить",
      "unapprove": "Отменить утверждение",
      "approveAndPay": "Утвердить и выплатить",
      "recordPayment": "Провести выплату",
      "approvedOn": "Утверждено {{date}}",
      "paid": "выплачено {{amount}}",
      "remaining": "остаток {{amount}}",
      "owed": "начислено {{amount}}",
      "settled": "выплачено полностью",
      "nothingToPay": "Нечего выплачивать",
      "date": "Дата",
      "cash": "Наличные",
      "bank": "Банк",
      "addBank": "Добавить банк",
      "removeLeg": "Удалить",
      "chooseBank": "Банк",
      "summary": "{{count}} чел. · {{amount}}",
      "submit": "Выплатить",
      "cancel": "Отмена",
      "noPayouts": "Выплат пока нет.",
      "history": "Выплаты",
      "void": "Удалить выплату",
      "approveConfirm": {
        "title": "Утвердить этот расчёт?",
        "body": "После этого суммы фиксируются и пересчёт станет невозможен. Пока нет ни одной выплаты, утверждение можно отменить.",
        "ok": "Утвердить",
        "cancel": "Отмена"
      },
      "unapproveConfirm": {
        "title": "Отменить утверждение?",
        "body": "Расчёт снова станет доступен для пересчёта.",
        "ok": "Отменить утверждение",
        "cancel": "Закрыть"
      },
      "voidConfirm": {
        "title": "Удалить эту выплату?",
        "body": "{{amount}} вернётся в остаток сотрудника {{name}}, а запись в кассе будет сторнирована.",
        "ok": "Удалить",
        "cancel": "Отмена"
      },
      "approved": "Расчёт утверждён.",
      "unapproved": "Утверждение отменено.",
      "recorded": "Выплата проведена.",
      "voided": "Выплата удалена.",
      "total": "Всего начислено",
      "paidLabel": "Выплачено",
      "remainingLabel": "Остаток",
      "payMany": "Выплатить нескольким",
      "exitBatch": "Завершить выбор",
      "colName": "Сотрудник",
      "colOwed": "Начислено",
      "colPaid": "Выплачено",
      "colRemaining": "Остаток",
      "partial": "частично",
      "due": "к выплате",
      "nothingToPayGroup": "{{count}} без выплат в этом периоде",
      "countDue": "{{count}} к выплате",
      "countDone": "{{count}} готово",
      "colPayment": "Выплата",
      "people": "{{count}} сотрудников",
      "payThis": "Выплатить…"
    },
    "nav": {
      "periods": "Периоды",
      "adjustments": "Корректировки",
      "report": "Выработка",
      "settings": "Настройки",
      "audit": "История"
    },
    "adjust": {
      "title": "Корректировки",
      "add": "Добавить корректировку",
      "none": "По этим фильтрам ничего не найдено",
      "filterEmployee": "Сотрудник",
      "filterType": "Тип",
      "allEmployees": "Все сотрудники",
      "allTypes": "Все типы",
      "systemGenerated": "Создано системой",
      "recurringSpan": "ежемесячно, {{from}} → {{to}}",
      "recurringOpen": "ежемесячно, с {{from}}",
      "unknownEmployee": "Неизвестный сотрудник",
      "family": {
        "BONUS": "Премия",
        "PENALTY": "Штраф",
        "CORRECTION": "Корректировка"
      },
      "kind": "Вид",
      "employee": "Сотрудник",
      "amount": "Сумма",
      "date": "Дата",
      "reason": "Причина",
      "recurUntil": "Повторять до",
      "adds": "добавит +{{amount}}",
      "deducts": "удержит −{{amount}}",
      "save": "Сохранить",
      "cancel": "Отмена",
      "saved": "Корректировка сохранена",
      "type": {
        "BONUS_ONE_OFF": "Премия",
        "BONUS_RECURRING": "Регулярная премия",
        "BONUS_KPI": "Премия по KPI",
        "PENALTY_ABSENCE": "Штраф — прогул",
        "PENALTY_LATENESS": "Штраф — опоздание",
        "PENALTY_DAMAGE": "Штраф — ущерб",
        "CORRECTION_ADD": "Корректировка (начисление)",
        "CORRECTION_DEDUCT": "Корректировка (удержание)",
        "CARRY_FORWARD": "Перенесённый остаток"
      },
      "endRecurrence": {
        "action": "Прекратить повторение",
        "title": "Прекратить эту премию после даты?",
        "body": "Уже выплаченное остаётся. После выбранной даты выплат не будет.",
        "field": "Прекратить после",
        "ok": "Прекратить",
        "cancel": "Отмена",
        "done": "Повторение прекращено"
      },
      "revoke": {
        "action": "Удалить",
        "title": "Удалить эту корректировку?",
        "body": "Она удаляется из всех невыплаченных периодов, включая прошедшие.",
        "ok": "Удалить",
        "cancel": "Отмена",
        "done": "Корректировка удалена"
      },
      "staleness": {
        "affectsRun": "Расчёт уже охватывает {{date}}, и его суммы больше не включают это.",
        "openRun": "Открыть расчёт",
        "noPeriod": "Ни один период не охватывает {{date}}, поэтому это не будет выплачено, пока не созданы периоды."
      },
      "groupFamily": "Категория",
      "groupType": "Тип",
      "short": {
        "BONUS_ONE_OFF": "Разовый",
        "BONUS_RECURRING": "Повторяющийся",
        "BONUS_KPI": "KPI",
        "PENALTY_ABSENCE": "Прогул",
        "PENALTY_LATENESS": "Опоздание",
        "PENALTY_DAMAGE": "Ущерб",
        "CORRECTION_ADD": "Добавить",
        "CORRECTION_DEDUCT": "Вычесть",
        "CARRY_FORWARD": "Перенос"
      },
      "err": {
        "employee": "Выберите сотрудника",
        "amount": "Введите сумму от 0,01 до 1 000 000",
        "date": "Выберите дату",
        "reason": "Укажите причину (макс. 500 символов)",
        "recurUntil": "Дата окончания должна быть позже даты вступления в силу"
      }
    },
    "settings": {
      "title": "Настройки зарплаты",
      "editing": "Редактируется",
      "orgDefault": "Значения по умолчанию организации",
      "thisBranch": "Этот филиал",
      "orgDefaultLocked": "У филиала свои настройки, поэтому значения организации здесь не читаются.",
      "cycle": "Цикл",
      "prorationBasis": "Основа пропорции",
      "splitDay": "День разделения",
      "inheriting": "Филиал использует настройки организации.",
      "overridden": "У филиала свои настройки.",
      "orgWarning": "Это значение по умолчанию для всех филиалов без собственных настроек.",
      "periodsWarning": "За {{year}} уже создано периодов: {{count}}. Смена цикла повлияет только на периоды, созданные позже.",
      "confirmOrg": {
        "title": "Изменить настройки организации?",
        "body": "Это затронет все филиалы без собственных настроек.",
        "ok": "Изменить",
        "cancel": "Отмена"
      },
      "save": "Сохранить",
      "saved": "Настройки сохранены",
      "cycleValue": {
        "MONTHLY": "Ежемесячно",
        "SEMI_MONTHLY": "Два раза в месяц",
        "WEEKLY": "Еженедельно"
      },
      "basisValue": {
        "CYCLE_SHARE": "Доля цикла",
        "SCHEDULED_DAYS": "Плановые дни",
        "EQUAL_SPLIT": "Поровну"
      },
      "equalSplitWeeklyHint": "«Поровну» нельзя использовать с еженедельным циклом."
    },
    "report": {
      "title": "Выработка по сотрудникам",
      "subtitle": "Валовая выработка — до вычета процента; не включает оклад, премии и штрафы.",
      "from": "С",
      "to": "По",
      "employee": "Сотрудник",
      "allEmployees": "Все сотрудники",
      "run": "Показать",
      "transactions": "Транзакции",
      "generatedOutput": "Выработка",
      "none": "За эти даты выработки нет",
      "toPayroll": "Для фактической оплаты откройте расчёт"
    },
    "export": "Экспорт",
    "exporting": "Выгрузка…",
    "audit": {
      "title": "История",
      "empty": "Записей пока нет.",
      "emptyFiltered": "Нет записей, соответствующих фильтрам.",
      "screenTitle": "История зарплат",
      "filterAction": "Действие",
      "filterEmployee": "Сотрудник",
      "filterFrom": "С",
      "filterTo": "По",
      "filterAll": "Все",
      "reset": "Сбросить",
      "count": "{{count}} записей",
      "action": {
        "RUN_CALCULATE": "Рассчитано",
        "RUN_APPROVE": "Утверждено",
        "RUN_UNAPPROVE": "Утверждение отменено",
        "PAYOUT_RECORD": "Выплачено",
        "PAYOUT_VOID": "Выплата удалена",
        "ADJUSTMENT_CREATE": "Добавлена корректировка",
        "ADJUSTMENT_REVOKE": "Корректировка отменена",
        "RATE_SET": "Изменена ставка"
      }
    }
  },
  "SALARY": {
    "gel": "GEL",
    "wantContinue": "Вы уверены, что хотите продолжить?",
    "COLUMN": {
      "employee": "работник",
      "generatedCash": "Заработанный (GEL)",
      "generatedSale": "Продукты",
      "sum": "Сумма (GEL)",
      "remainSalary": "Будет издан",
      "salarySumOut": "Выпущен"
    },
    "comment": "Укажите комментарий",
    "createSalary": "Выплата зарплаты",
    "detailedSalary": "Зарплата по процедурам",
    "excelExport": "Excel экспорт",
    "noExportData": "Нет данных для экспорта",
    "totalLabel": "Итого",
    "sumLabel": "Сумма",
    "selectedCount": "Выбрано",
    "payDisabledForBranch": "В этом филиале зарплата выдаётся на экране «Начисление зарплат».",
    "payFailed": "Не удалось выдать зарплату."
  },
  "SERVICE_PRODUCT": {
    "name": "დასახელება",
    "price": "გასაყიდი ფასი",
    "time": "დრო",
    "serviceCategory": "კატეგორია",
    "autoPriceView": "ფასი ავტომატურად",
    "autoTimeView": "დრო ავტომატურად",
    "autoFix": "ავტ.გადატანა ფიქს. ხარჯში",
    "fixSum": "ფიქს. ხარჯში",
    "products": "პროდუქტები",
    "product": {
      "new_product": "ახალი პროდუქტი",
      "name": "დასახელება",
      "gram": "გრამი",
      "quantity": "ცალი",
      "pricePerItem": "ცალის ფასი",
      "grPerItem": "გრამი ცალში",
      "expencePrice": "ხარჯის ღირებულება"
    },
    "notification": "შეტყობინება",
    "days": "შეხსენების ინტერვალი",
    "notificationMessage": "შეხსენების შეტყობინება",
    "providers": "პროვაიდერები",
    "provider": {
      "name": "სადაზღვევო",
      "productName": "სადაზღვევო პროდუქტი",
      "price": "სადაზღვევო ფასი"
    }
  },
  "PRODUCT": {
    "barcode": "ბარკოდი",
    "name": "დასახელება",
    "code": "პროდუცტის კოდი",
    "productCategory": "კატეგორია",
    "distributor": "მომწოდებელი",
    "pricePerItem": "მისაღები ფასი",
    "salePricePerItem": "გასაყიდი ფასი",
    "grPerItem": "გრამი ცალში",
    "gram": "გრამი",
    "quantity": "რაოდენობა",
    "restGr": "ნაშთი(გრამი)",
    "buyDate": "შეძენის თარიღი",
    "bestBefore": "ვარგისია",
    "avgPrice": "საშუალო ფასი",
    "isSpend": "გასავალში გატარება",
    "comment": "კომენტარი",
    "accountingDate": "აღრიცხვის თარიღი"
  },
  "EVENT_TYPE": {
    "SYSTEM": "Системное",
    "SYSTEM_ADMIN": "Системное",
    "CUSTOM": "Пользовательское"
  },
  "EVENT_KEY": {
    "COMPLETED": "После визита",
    "BOOKING_UPDATE": "Запись изменена",
    "BOOKED": "Бронь подтверждена",
    "BOOKING_REMINDER": "Напоминание о визите",
    "BOOKING_DELETED": "Запись отменена",
    "PERIODIC_REMINDER": "Пора записаться снова",
    "ONLINE_BOOKING_INCOME": "Онлайн-запись",
    "ONLINE_BOOKING_CANCEL": "Онлайн-запись отменена",
    "VERIFICATION_SMS": "Код подтверждения",
    "OFFER_EXPIRY_WARNING": "Ваучер скоро истекает",
    "OFFER_PURCHASE_CONFIRMATION": "Ваучер куплен",
    "OFFER_MERCHANT_NOTIFICATION": "Ваучер продан",
    "PACKAGE_PURCHASE_CONFIRMATION": "Пакет куплен",
    "PACKAGE_USAGE": "Услуга из пакета",
    "PACKAGE_BATCH_USAGE": "Несколько услуг из пакета",
    "PACKAGE_EXPIRED": "Пакет истёк",
    "PACKAGE_EXPIRY_WARNING": "Пакет скоро истекает",
    "INVOICE_GENERATED": "Счёт создан",
    "EMPLOYEE_PASSWORD_RESET": "Сброс пароля сотрудника",
    "USER_PASSWORD_RESET": "Сброс пароля пользователя"
  },
  "SCHEDULE_PERIOD_TYPE": {
    "NOW": "მაშინვე",
    "ONE_TIME": "ერთჯერადი",
    "DAILY": "ყოველდღიური",
    "Monthly": "ყოველთვიური",
    "Yerly": "ყოველწლიური"
  },
  "USER_ROLE": {
    "USER": "Пользователь",
    "EMPLOYEE": "Сотрудник",
    "ADMIN": "Админ",
    "SUPER_ADMIN": "Супер админ",
    "ADMINISTRATOR": "Администратор"
  },
  "header": {
    "search": {
      "placeholder": "Найти резервацию"
    },
    "account": {
      "dropdown": {
        "profile": "Профиль",
        "changePassword": "Поменять пароль",
        "logOut": "Выйти из системы"
      }
    }
  },
  "footer": {
    "title": "Все права защищены"
  },
  "auth": {
    "welcome": {
      "title": "Удачного рабочего дня",
      "subTitle": "В случае возникновения каких-либо вопросов, пожалуйста, обращайтесь к администрации 0322500290"
    },
    "form": {
      "title": "Авторизация",
      "username": "Пользователь",
      "password": "Пароль",
      "button": "Авторизоваться",
      "twoFA": "SMS код",
      "resend": "Отправить повторно"
    },
    "biometric": {
      "or": "или",
      "loginButton": "Войти с биометрией",
      "enterUsername": "Пожалуйста, сначала введите имя пользователя",
      "loginFailed": "Биометрическая авторизация не удалась",
      "noCredentials": "Биометрическое устройство не зарегистрировано. Сначала зарегистрируйте устройство в настройках профиля.",
      "userNotFound": "Пользователь не найден",
      "cancelled": "Биометрическая авторизация отменена"
    }
  },
  "DASHBOARD": {
    "ANALYSIS": {
      "analysisOfTheDay": "Анализ дня",
      "newUser": "Новый пользователь",
      "allReservations": "все резервации",
      "finishedVisits": "Завершенные визиты",
      "visitsToBeMade": "Визиты, которые будут совершены",
      "totalRevenue": "Общий доход",
      "averageTicket": "Средний чек",
      "services": "Услуги",
      "products": "Продукция",
      "bookingDetails": "Детали бронирования",
      "pending": "Ожидание",
      "inProgress": "В процессе",
      "canceled": "Отменено",
      "noShow": "Не явился",
      "occupancy": "Загруженность",
      "today": "Сегодня",
      "week": "Неделя",
      "month": "Месяц",
      "availableSlots": "Свободное время",
      "tomorrow": "Завтра",
      "noSlots": "Нет свободного времени",
      "min": "мин",
      "clientStats": "Статистика клиентов",
      "topVisitors": "Топ посетители",
      "topSpenders": "Топ по тратам",
      "newClients": "Новые клиенты",
      "newClientsRevenue": "Доход от новых клиентов",
      "returningClients": "Вернувшиеся клиенты",
      "returningClientsRevenue": "Доход от вернувшихся",
      "client": "Клиент",
      "visits": "Визиты",
      "spent": "Потрачено",
      "noData": "Нет данных",
      "employees": "Сотрудники",
      "rooms": "Комнаты",
      "combined": "Общая",
      "salesTrend": "Динамика продаж",
      "days": "дней",
      "vsYesterday": "по сравнению со вчера"
    },
    "statistic": {
      "title": "Обзор",
      "salary": "Доход и зарплата",
      "latestReservations": "Последние резервации",
      "pastReservations": "Прошлые резервации",
      "reservationsMadeToday": "Записано сегодня"
    }
  },
  "profile": {
    "userName": "Имя пользователя",
    "phoneNumber": "Номер телефона",
    "idNumber": "Идентификационный номер",
    "gender": "Пол",
    "dateOfBirth": "Дата рождения",
    "email": "Электронная почта,Mail",
    "city": "Город",
    "address": "Адрес",
    "additionalInformation": "Дополнительная информация",
    "currentPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "repeatPassword": "Повторите пароль",
    "changePassword": "Поменять пароль",
    "updateProfile": "Обновить профиль",
    "passwordChange": "Пароль изменен",
    "disable2FA": "Отключить двухфакторную аутентификацию",
    "enable2FA": "Включить двухфакторную аутентификацию",
    "2FAEnabled": "Двухфакторная аутентификация включена",
    "2FADisabled": "Двухфакторная аутентификация отключена",
    "2FA": "Двухфакторная аутентификация",
    "branch": {
      "title": "Филиалы",
      "add": "Добавить филиал",
      "edit": "Редактировать филиал",
      "delete": "Удалить филиал",
      "name": "Название филиала",
      "physicalAddress": "Физический адрес",
      "mobile": "Мобильный",
      "email": "Электронная почта",
      "city": "Город",
      "country": "Страна",
      "whStart": "Время начала рабочего дня",
      "whEnd": "Время окончания рабочего дня",
      "smsBrandName": "SMS Brand Name",
      "deleteConfirm": "Вы уверены, что хотите удалить этот филиал?",
      "deleteSuccess": "Филиал успешно удален",
      "invoiceOrganizationName": "Название организации в инвойсе",
      "invoiceOrganizationTaxId": "Идентификационный номер организации в инвойсе",
      "settings": "Настройки"
    },
    "biometric": {
      "title": "Биометрическая аутентификация",
      "deviceName": "Устройство",
      "lastUsed": "Последнее использование",
      "noDevices": "Биометрические устройства не зарегистрированы",
      "addDevice": "Добавить устройство",
      "removeConfirm": "Вы уверены, что хотите удалить это устройство?",
      "registerSuccess": "Биометрическое устройство успешно зарегистрировано",
      "registerFailed": "Не удалось зарегистрировать биометрическое устройство",
      "removeSuccess": "Устройство успешно удалено",
      "removeFailed": "Не удалось удалить устройство",
      "noPlatformAuth": "Touch ID или Windows Hello недоступны на этом устройстве. Используйте устройство с биометрическим оборудованием."
    }
  },
  "employee": {
    "add": "Добавить",
    "massiveAddition": "Массивное дополнение",
    "download": "Скачать",
    "delete": "Вы уверены, что хотите удалить?",
    "rollback": "Восстановит",
    "rollbackConfirm": "Вы уверены, что хотите восстановит?",
    "resetPassword": "Вы уверены, что хотите завершить день?",
    "addEmployee/edit": "Добавление работника/редактировать",
    "addPosition/edit": "Добавить позицию/редактировать",
    "addProcedure/edit": "Добавить процедуру/отредактировать",
    "addRestDay": "Добавить отдых",
    "procedure": "процедура",
    "tabs": {
      "employees": "работники",
      "positions": "должности"
    },
    "search": {
      "searchWord": "Поисковое слово",
      "position": "должность"
    },
    "form": {
      "firstName": "Имя",
      "lastName": "Фамилия",
      "phoneNumber": "Номер телефона",
      "homePhone": "Номер домашнего телефона",
      "idNumber": "Идентификационный номер",
      "gender": "Пол",
      "female": "Женский",
      "male": "Мужской",
      "dateOfBirth": "Дата рождения",
      "email": "Электронная почта",
      "salaryType": "Тип зарплаты",
      "fixedSalary": "Фиксированная зарплата",
      "%ofGenerating": "% от генерирующего",
      "additionalInformation": "Дополнительная информация",
      "showInCalendar": "Показать в календаре",
      "showInApplication": "Показать в приложении",
      "save": "Сохранить",
      "created": "Созданный",
      "errors": {
        "title": "Ошибка",
        "requiredFields": "Заполните обязательные поля (включая имя и фамилию).",
        "saveFailed": "Не удалось сохранить"
      },
      "salaryTypes": {
        "FIXED": "Фиксированная зарплата",
        "OUTPUT": "% от генерирующего",
        "ALL": "все"
      }
    },
    "detailView": {
      "statistics": "Статистика",
      "reservations": "резервации",
      "completedVisits": "Завершенные визиты",
      "amountEarned": "Заработанная сумма",
      "issuedAmount": "Выпущенная сумма",
      "information": "Информация",
      "procedures": "Процедуры",
      "finances": "Финансы",
      "recoveryPassword": "Восстановление пароля",
      "workSchedule": "График работы",
      "employeeProcedure": " процедура работника",
      "identitySection": "Личные данные",
      "contactSection": "Контактные данные",
      "employmentSection": "Данные о трудоустройстве"
    }
  },
  "services": {
    "addProcedure/edit": "Добавить процедуру/редактировать",
    "addSpecialProcedure/edit": "Добавить спец.процедуру/редактировать",
    "addProduct/edit": " Добавить продукт/отредактировать",
    "search": {
      "searchWord": " Поисковое слово",
      "vat": "С НДС"
    },
    "tabs": {
      "procedures": "Процедуры",
      "specialProcedures": "Спец. процедуры",
      "categories": "Категории",
      "regular": "Услуги",
      "offers": "Предложения",
      "packages": "Пакеты"
    },
    "sections": {
      "basicInfo": "Основная информация",
      "pricing": "Цена и длительность",
      "settings": "Настройки"
    },
    "offers": {
      "offerName": "Предложение",
      "remaining": "Остаток",
      "expires": "Срок",
      "prepaid": "Предоплачено",
      "noOffers": "Предложения не найдены",
      "left": "осталось",
      "reserved": "использовано"
    },
    "packages": {
      "packageName": "Пакет",
      "coveredByPackage": "Покрыто пакетом",
      "noPackages": "Пакеты не найдены",
      "noActivePackage": "Активные пакеты не найдены",
      "noActivePackageDescription": "В данный момент нет доступных активных пакетов",
      "noPackagesForSearch": "Пакеты по запросу «{{term}}» не найдены",
      "fromTemplate": "Из шаблона",
      "adHoc": "Индивидуальный",
      "adHocBundle": "Индивидуальный пакет",
      "addProcedure": "Добавить процедуру",
      "noProcedures": "Добавьте процедуры в пакет",
      "selectProcedure": "Выберите процедуру",
      "total": "Итого",
      "validityDays": "Срок (дни)",
      "buyForAnother": "Купить для другого клиента",
      "selectBeneficiary": "Выберите получателя",
      "giftFrom": "Подарок от",
      "boughtFor": "Куплено для",
      "saveToTemplates": "Сохранить в шаблоны",
      "templateName": "Название пакета",
      "templateNameRequired": "Пожалуйста, введите название пакета",
      "templateSaved": "Сохранено в шаблоны",
      "templateSaveFailed": "Продано, но сохранить в шаблоны не удалось"
    },
    "column": {
      "title": "Название",
      "price": "Цена",
      "time": "Время",
      "priceAutomatically": "Цена автоматически",
      "timeAutomatically": "Время автоматически",
      "category": "Категория",
      "provider": "Поставщик",
      "vat": "НДС",
      "created": "Созданный",
      "providerPrice": "Цена поставщика",
      "color": "Цвет",
      "position": "должности",
      "reminder": "Напоминание",
      "reminderPeriod": "Период напоминания",
      "reminderSmsTemplate": "Шаблон SMS-напоминания"
    },
    "form": {
      "title": "Название",
      "salePrice": "Цена продажи",
      "time": "Время",
      "category": "Категория",
      "priceAutomatically": "Цена автоматически",
      "timeAutomatically": "Время автоматически",
      "automaticTransfer": "Автоматический перевод на фиксированную стоимость",
      "products": "Продукты",
      "notification": "Уведомление",
      "gram": "Грамм",
      "piece": "Единицы",
      "reminderInterval": "Интервал напоминания",
      "reminderNotification": "Уведомление с напоминанием",
      "reminderMessage": "Укажите сообщение с напоминанием",
      "employee": "работник",
      "%generating": "% от генерирующего",
      "fixedSalary": "Фиксированная зарплата",
      "fixSum": "фиксированную стоимость",
      "maxParallelBookings": "Макс. параллельных бронирований",
      "maxParallelBookingsHint": "0 = без ограничений, N = максимальное количество параллельных бронирований",
      "serviceType": "Тип услуги",
      "standard": "Стандартный",
      "minute": "Минуты",
      "minute-price": "Цена за минуту",
      "minute-discount": "Скидка за минуту",
      "price": "Цена",
      "discount": "Скидка",
      "unit": "Единица",
      "inPiece": "грамм в единице",
      "willUse": "Будет израсходовано",
      "ncsps": "Коды NCSP"
    },
    "category": {
      "add": {
        "title": "Добавить/отредактировать категорию"
      }
    },
    "notifications": {
      "service": "Услуга",
      "updated": "Успешно обновлено",
      "created": "Успешно создано",
      "error": "Ошибка"
    },
    "v2": {
      "searchPlaceholder": "Поиск по названию услуги",
      "summary": "Показано услуг: {{total}}",
      "serviceCount": "Услуг: {{count}}",
      "uncategorized": "Без категории",
      "loadFailed": "Не удалось загрузить",
      "toggleFailed": "Не удалось сохранить изменение",
      "column": {
        "name": "Название",
        "onlineBooking": "Онлайн-запись",
        "price": "Цена",
        "duration": "Длительность",
        "break": "Тех. перерыв",
        "materials": "Материалы",
        "employees": "Сотрудники"
      },
      "form": {
        "newTitle": "Новая услуга",
        "newTitleSpecial": "Новая спец. процедура",
        "editTitleSpecial": "Редактирование спец. процедуры",
        "editTitle": "Редактирование услуги",
        "tab": {
          "main": "Основные параметры",
          "online": "Онлайн-запись",
          "languages": "Языки",
          "products": "Продукты",
          "ncsp": "Коды NCSP",
          "employees": "Сотрудники",
          "rooms": "Кабинеты",
          "activity": "Активность"
        },
        "name": "Название",
        "category": "Категория",
        "basePrice": "Базовая цена",
        "useRange": "Указать диапазон цен",
        "priceFrom": "от",
        "priceTo": "до",
        "duration": "Длительность услуги",
        "hoursShort": "ч",
        "minutesShort": "мин",
        "onlineBooking": "Онлайн-запись",
        "publicName": "Название для онлайн-записи",
        "publicDescription": "Описание",
        "publicHint": "Это видит клиент при онлайн-записи. Не зависит от внутреннего названия.",
        "languagesHint": "Добавьте переводы, чтобы клиент видел услугу на своём языке. Если перевод пуст, используется основное название.",
        "lang": {
          "ka": "Грузинский",
          "en": "Английский",
          "ru": "Русский"
        },
        "standard": "Стандартный",
        "optional": "Необязательно",
        "fromMain": "Взято из основных параметров",
        "nameRequired": "Введите название",
        "rangeIncomplete": "Для диапазона нужны обе границы",
        "saved": "Сохранено",
        "saveFailed": "Не удалось сохранить",
        "vat": "Облагается НДС",
        "saveFirst": "Сначала сохраните услугу — потом сможете добавить здесь.",
        "viewOnly": "Вы можете просматривать эту услугу, но у вас нет прав на её изменение."
      },
      "create": "Создать",
      "title": "Категории услуг",
      "subtitle": "Услуги",
      "on": "Вкл",
      "off": "Выкл",
      "emptyCategory": "В этой категории пока нет услуг",
      "addService": "Добавить",
      "filter": {
        "all": "Все",
        "online": "Онлайн-запись",
        "inSalon": "Только в салоне",
        "special": "Спец. процедуры"
      },
      "searchEmpty": "Услуга с таким названием не найдена",
      "searchTruncated": "Показаны первые 200 совпадений — уточните поиск.",
      "chooser": {
        "title": "Что вы хотите создать?",
        "new": "Новое",
        "category": {
          "title": "Категория услуг",
          "hint": "Группа похожих услуг, например стрижки"
        },
        "service": {
          "title": "Услуга",
          "hint": "Отдельная услуга, которую выполняет специалист, например маникюр"
        },
        "special": {
          "title": "Спец. процедура",
          "hint": "Выполняется только в салоне — без онлайн-записи и без кода NCSP"
        },
        "package": {
          "title": "Пакет услуг",
          "hint": "Несколько услуг одним предложением, например маникюр и педикюр"
        }
      },
      "category": {
        "newTitle": "Новая категория услуг",
        "editTitle": "Редактирование категории",
        "namePlaceholder": "Например: Стрижки",
        "useOnlineName": "Использовать другое название для онлайн-записи",
        "onlineName": "Название для онлайн-записи",
        "nameRequired": "Введите название категории",
        "created": "Категория создана",
        "saved": "Категория сохранена",
        "languagesHint": "Добавьте переводы, чтобы категория корректно отображалась на других языках.",
        "fallsBack": "Если оставить пустым, показывается грузинское название",
        "viewOnly": "Вы можете просматривать эту категорию, но у вас нет прав на её изменение.",
        "colorHint": "Записи на услуги этой категории отображаются в календаре этим цветом.",
        "reminderHint": "Отправляет клиенту SMS через заданное количество дней после визита на услугу из этой категории.",
        "reminderDays": "Отправить через (дней)",
        "reminderDaysHint": "Отсчитывается от даты визита.",
        "reminderPlaceholders": "Используйте {firstname} для имени клиента и {serviceCategoryName} для названия категории.",
        "reminderIncomplete": "Напоминание не будет отправлено, пока не заполнены количество дней и текст SMS.",
        "chooseColor": "Выбрать цвет",
        "noColor": "Цвет не выбран"
      },
      "noBreak": "Нет",
      "minutesShort": "{{count}} мин",
      "materialCount": "{{count}} материалов",
      "reorderFailed": "Не удалось сохранить порядок",
      "materials": {
        "search": "Поиск материала",
        "selected": "Выбранные материалы",
        "noneFound": "Материалы не найдены",
        "noneSelected": "Материалы ещё не выбраны",
        "lowStock": "Заканчивается",
        "inStock": "На складе {{count}}",
        "gram": "г",
        "piece": "шт",
        "costPerService": "Расход материалов на услугу",
        "servicePrice": "Цена услуги",
        "margin": "Маржа",
        "writeOffHint": "Материалы можно изменить в любой момент — откройте ячейку материалов в таблице.",
        "footerHint": "После сохранения эти материалы автоматически добавляются в каждую новую запись на услугу.",
        "title": "Привязка материалов",
        "expired": "Просрочен",
        "expiresOn": "Годен до {{date}}"
      },
      "breakHint": "Минуты, на которые кабинет остаётся занят после услуги",
      "rooms": {
        "tabLabel": "Кабинеты",
        "hint": "Отметьте кабинеты, в которых выполняется эта услуга.",
        "none": "В филиале нет кабинетов.",
        "selected": "Выбрано кабинетов: {{count}}",
        "saved": "Кабинеты сохранены",
        "saveFailed": "Не удалось сохранить кабинеты",
        "loadFailed": "Не удалось загрузить кабинеты"
      },
      "activity": {
        "none": "Изменений пока нет.",
        "unknown": "Неизвестно",
        "empty": "пусто",
        "yes": "Да",
        "no": "Нет",
        "loadFailed": "Не удалось загрузить историю",
        "action": {
          "CREATED": "Создание",
          "UPDATED": "Изменение",
          "DELETED": "Удаление",
          "ONLINE_BOOKING": "Онлайн-запись",
          "EMPLOYEES": "Сотрудники",
          "ROOMS": "Кабинеты",
          "PRODUCTS": "Продукты"
        },
        "count": "записей: {{count}}"
      },
      "addLink": "Добавить",
      "notSetShort": "—",
      "countSalon": "в салоне {{count}}",
      "countOnline": "онлайн {{count}}",
      "employeesDrawer": {
        "title": "Сотрудники услуги"
      },
      "import": {
        "title": "Импорт из Excel",
        "subtitle": "Массовое обновление цен и длительности и добавление новых услуг.",
        "dropTitle": "Перетащите файл Excel или выберите его на компьютере",
        "dropHint": "Формат xlsx, до 5 МБ",
        "choose": "Выбрать файл",
        "remove": "Удалить файл",
        "checkTitle": "Проверка файла",
        "checking": "Проверка...",
        "count": {
          "create": "Новые",
          "update": "Обновятся",
          "unchanged": "Без изменений",
          "warning": "Предупреждения",
          "error": "Ошибки"
        },
        "table": {
          "row": "Строка",
          "service": "Услуга",
          "message": "Сообщение"
        },
        "showAll": "Показать все строки",
        "showProblems": "Только строки с проблемами",
        "allClean": "В файле нет проблем.",
        "footerNote": "Строки с ошибками не будут записаны. Будет создано {{create}}, обновлено {{update}}.",
        "done": "Импорт завершён: создано {{create}}, обновлено {{update}}.",
        "resultDiffers": "Результат отличается от проверки: данные изменились после проверки файла.",
        "onlineSummary": "Онлайн-запись: включится {{on}}, выключится {{off}}",
        "cancel": "Отмена",
        "confirm": "Подтвердить импорт",
        "close": "Закрыть",
        "wrongType": "Принимаются только файлы .xlsx.",
        "tooLarge": "Файл больше 5 МБ.",
        "failed": "Не удалось обработать файл. Попробуйте ещё раз.",
        "redesignDisabled": "Новый экран услуг отключён для этого филиала.",
        "forbidden": "У вас нет доступа к этому филиалу.",
        "column": {
          "id": "ID",
          "name": "Название",
          "category": "Категория",
          "price": "Цена",
          "discountPrice": "Цена со скидкой",
          "time": "Длительность",
          "serviceType": "Тип",
          "vat": "НДС",
          "autoPrice": "Автоматически показывать цену",
          "autoTime": "Автоматически показывать время",
          "technicalBreak": "Технический перерыв",
          "maxParallel": "Макс. параллельных записей",
          "autoFix": "Автоперенос в фикс. расход",
          "fixSum": "Сумма фикс. расхода",
          "onlineBooking": "Онлайн-запись"
        },
        "msg": {
          "nameRequired": "Название обязательно",
          "notANumber": "«{{column}}» не является числом",
          "negative": "«{{column}}» не может быть отрицательным",
          "notPositive": "«{{column}}» должно быть больше 0",
          "invalidValue": "«{{column}}»: недопустимое значение",
          "serviceNotFound": "Услуга не найдена в этом филиале",
          "duplicateId": "Этот ID повторяется в файле",
          "duplicateName": "Дублирующееся название в этой категории",
          "categoryWillBeCreated": "Будет создана новая категория: {{name}}",
          "priceRangeKept": "У услуги есть диапазон цен: цена изменится, диапазон останется",
          "notXlsx": "Файл не является Excel (.xlsx)",
          "emptyFile": "Файл пуст",
          "missingNameColumn": "В файле нет столбца «Название»",
          "tooManyRows": "В файле больше {{max}} строк",
          "unknownColumn": "Неизвестный столбец «{{name}}» пропущен",
          "unknown": "Неизвестная ошибка",
          "tooLarge": "Файл слишком большой после распаковки.",
          "notWholeNumber": "«{{column}}» должно быть целым числом",
          "breakNotForMinute": "У услуги типа MINUTE нет технического перерыва (0 или пусто)",
          "fixSumIgnored": "Перенос выключен, сумма сохранится как 0",
          "onlineBookingUnavailable": "Онлайн-запись выключена в организации"
        }
      },
      "excel": {
        "menu": "Действия с Excel",
        "export": "Экспорт в Excel",
        "exportHint": "Все услуги с текущим фильтром.",
        "import": "Импорт из Excel",
        "importHint": "Массовое обновление цен и длительности.",
        "template": "Скачать шаблон",
        "templateHint": "Пустой файл с правильными столбцами.",
        "exportFailed": "Не удалось выполнить экспорт.",
        "templateFailed": "Не удалось скачать шаблон."
      },
      "delete": {
        "titleService": "Удаление услуги: {{name}}",
        "titleServiceNoName": "Удаление услуги",
        "titleCategory": "Удаление категории: {{name}}",
        "titleCategoryNoName": "Удаление категории",
        "checking": "Проверка...",
        "confirmService": "Услуга будет удалена. Вы уверены?",
        "confirmCategory": "Категория будет удалена. Вы уверены?",
        "historyKept": "Прошлые визиты сохранятся.",
        "blocked": "Нельзя удалить",
        "bookings": "Предстоящих записей: {{count}}",
        "offers": "Активных предложений: {{count}}",
        "packages": "Активных пакетов: {{count}}",
        "purchases": "Купленных пакетов с неиспользованными сеансами: {{count}}",
        "vouchers": "Неиспользованных ваучеров: {{count}}",
        "services": "В категории услуг: {{count}} — сначала удалите или перенесите их",
        "delete": "Удалить",
        "cancel": "Отмена",
        "close": "Закрыть",
        "done": "Удалено",
        "failed": "Не удалось удалить. Попробуйте ещё раз.",
        "forbidden": "У вас нет доступа к этому филиалу.",
        "redesignDisabled": "Новый экран услуг отключён для этого филиала.",
        "notFound": "Не найдено — возможно, уже удалено.",
        "button": "Удалить"
      }
    }
  },
  "users": {
    "consentsHistory": "Согласия и верификация",
    "consent": {
      "documentType": "Тип документа",
      "verified": "Верифицирован",
      "verifiedYes": "Да",
      "verifiedNo": "Нет",
      "search": "Поиск",
      "clear": "Очистить",
      "type": {
        "PROCEDURE_CONSENT": "Согласие на процедуру",
        "CUSTOMER_VERIFICATION": "Верификация клиента",
        "DATA_PROCESSING": "Обработка данных",
        "INFORMED_CONSENT": "Информированное согласие"
      },
      "status": {
        "VERIFIED": "Верифицирован",
        "PENDING": "Ожидание",
        "CONFIRMED": "Подтверждён",
        "EXPIRED": "Истёк"
      },
      "column": {
        "type": "Тип",
        "status": "Статус",
        "code": "Код",
        "verified": "Верифицирован",
        "verifiedAt": "Дата верификации",
        "mobilePhone": "Телефон",
        "date": "Дата"
      }
    },
    "gel": "GEL",
    "min": "Мин.",
    "information": "информация",
    "addUser/edit": "Добавить пользователя/редактировать",
    "upBalance": "Пополните баланс",
    "minutes": "Минут",
    "amount": "Сумма",
    "numberMinutes": "Количество минут",
    "typePayment": "Тип платежа",
    "moneyMode": "Денежная проводка",
    "withoutMoney": "Без денежной проводки",
    "withMoney": "С денежной проводкой",
    "moneyRequired": "Операция с денежной проводкой требует суммы больше 0",
    "comment": "Комментарий",
    "operationType": "Тип операции",
    "topUpBalance": "Пополнить баланс",
    "returnBalance": "Возвратный баланс",
    "balanceAmount": "сумма баланса",
    "historyVisits": "История посещений",
    "transactions": "Операции",
    "completedSuccessfully": "завершено успешно",
    "balanceFilledSuccessfully": "Баланс успешно пополнен",
    "balanceNotEnough": "Баланса не хватает",
    "search": {
      "searchWord": "Поисковое слово",
      "branch": "Ветка",
      "userSource": "Источник пользователя",
      "withBalance": "С балансом",
      "withMinutes": "С минутами"
    },
    "transactionDate": "Дата транзакции",
    "column": {
      "cardNo": "# Карты",
      "name": "Имя",
      "lastName": "Фамилия",
      "identificationNo": "Идентификационный #",
      "female": "Женский",
      "male": "Мужской ",
      "gender": "Пол",
      "dateOfBirth": "Дата рождения",
      "phoneNumber": "Номер телефона",
      "branch": "Ветка",
      "userSource": "Источник пользователя",
      "created": "Созданный",
      "role": "Роль",
      "service": "Сервись",
      "price": "Цена",
      "balance": "Баланс(₾)",
      "minutes": "Минут",
      "reservationTime": "Время резервации",
      "startingTime": "Время начала",
      "finishingTime": "Время окончания",
      "employee": "работник",
      "description": "Описание"
    },
    "form": {
      "cardNo": "# Карты",
      "name": "Имя",
      "lastName": "Фамилия",
      "phoneNumber": "Номер телефона",
      "homePhone": "Номер домашнего телефона",
      "idNumber": "Идентификационный номер",
      "female": "Женский",
      "male": "Мужской",
      "gender": "Пол",
      "dateOfBirth": "Дата рождения",
      "email": "Электронная почта",
      "additionalInformation": "Дополнительная информация",
      "role": "Роль",
      "created": "Созданный",
      "userSource": "Источник пользователя",
      "smsLanguage": "Язык SMS",
      "smsLanguageKa": "Грузинский",
      "smsLanguageRu": "Русский",
      "smsLanguageEn": "Английский",
      "verification": "Верификация",
      "notSet": "Не задан",
      "smsLanguageHint": "Язык, на котором клиент получает SMS",
      "smsLanguageSaved": "Язык SMS сохранён",
      "smsLanguageError": "Не удалось сохранить язык",
      "selectUser": "Изменить клиента",
      "updateUser": "Редактировать клиента",
      "unknownUser": "Неизвестный клиент",
      "smsLanguageDefault": "по умолчанию филиала"
    },
    "offers": {
      "tabTitle": "Пакеты",
      "buyPackage": "Купить пакет",
      "noPackages": "Нет купленных пакетов",
      "columns": {
        "package": "Пакет",
        "status": "Статус",
        "source": "Источник",
        "progress": "Прогресс",
        "price": "Цена",
        "validity": "Срок действия",
        "actions": "Действия"
      },
      "status": {
        "PURCHASED": "Куплен",
        "ACTIVE": "Активен",
        "USED": "Использован",
        "CANCELLED": "Отменён",
        "SHARED": "Общий"
      },
      "source": {
        "INTERNAL": "Внутренний",
        "EXTERNAL": "Внешний",
        "APP": "Приложение"
      },
      "activate": "Активировать",
      "purchaseModal": {
        "title": "Купить пакет",
        "selectPackage": "Выберите пакет",
        "paymentMethod": "Способ оплаты",
        "purchasePrice": "Цена покупки",
        "note": "Примечание",
        "cancel": "Отмена",
        "purchase": "Купить",
        "noPackagesAvailable": "Нет доступных пакетов для продажи",
        "success": "Пакет успешно куплен",
        "error": "Ошибка при покупке пакета"
      },
      "activateSuccess": "Пакет успешно активирован",
      "activateError": "Ошибка при активации пакета"
    },
    "ehr": {
      "onlyWithIntervention": "Только с вмешательствами"
    },
    "preferencesAndNotes": "Предпочтения и заметки",
    "visitPhotos": "Фото визитов",
    "giftPackages": "Полученные в подарок",
    "servicePackages": "Сервисные пакеты",
    "ownPackages": "Свои пакеты"
  },
  "calendar": {
    "gel": "GEL",
    "offerService": "Предложение",
    "packageService": "Пакет",
    "packageClearFailed": "Не удалось полностью очистить пакет предыдущего клиента",
    "serviceDeleted": "Услуга удалена",
    "minute": "Минут",
    "hours": "час",
    "day": "день",
    "sortEmployee": "Сортировать работника",
    "planVisit": "Планирование визита",
    "createUser": "Создать пользователя",
    "calendarTitle": "Календарь",
    "PlanVisit": "Планирование визита",
    "services": "Сервисы",
    "addProcedure": "Добавить процедуру",
    "addProduct": "Добавить продукт",
    "editProduct": "Редактировать продукт",
    "specialProcedures": "Специальные процедуры",
    "addSpecialProcedure": "Добавьте спецпроцедуру",
    "form": {
      "user": "Пользователь",
      "birthdayToday": "Сегодня день рождения",
      "birthdayGreeting": "Поздравление с днём рождения",
      "employee": "работник",
      "employeeLocked": "После добавления процедуры сотрудника изменить нельзя",
      "employeeBusy": "Сотрудник занят в это время",
      "startTime": "Время начала",
      "userRequest": "по желанию пользователя",
      "date": "Дата",
      "startingTime": "Время начала",
      "finishingTime": "Время окончания",
      "comment": "Комментарий",
      "fixatedExpense": "Фикс. расход",
      "expense": "расход",
      "paymentMethod": "Способ оплаты",
      "balance": "баланс",
      "available": "доступный",
      "cash": "Наличными ",
      "bank": "через банк",
      "minutes": "Минут",
      "exchange": "Обмен",
      "consignment": "консигнация",
      "bankTransfer": "Банковский перевод",
      "gel": "GEL",
      "sumTotal": "Общая сумма",
      "present": "подарок",
      "sendNotification": "Послать сообщение",
      "finish": "Завершение",
      "withCash": "Оплата наличными",
      "procedure": "Процедура",
      "procedureAndPrice": "Процедура и цена",
      "name": "Имя",
      "lastName": "Фамилия",
      "phoneNumber": "Номер телефона",
      "duration": "Продолжительность",
      "time": "Время",
      "price": "Цена",
      "discount": "скидка",
      "percent": "процент",
      "discountedPrice": "цена со скидкой",
      "fixatedSalary": "Фиксированная зарплата",
      "salary%": "% Зарплаты",
      "fromValue": "от стоимости",
      "numberProcedures": "количество процедур",
      "expenses": "Расходы",
      "products": "Продукты ",
      "gram": "Грамм",
      "quantity": "Количество",
      "product": "продукт",
      "piece": "Единицы",
      "specialProcedure": "специальная процедура",
      "specialist": "Специалист",
      "salary": "Зарплата",
      "inStock": "в наличии",
      "debt": "долг",
      "room": "Комната",
      "selectRoom": "Выберите комнату",
      "source": "Источник Бронирования",
      "sourcePlaceholder": "Выберите источник",
      "additionalEmployees": "Дополнительные сотрудники",
      "employees": "Сотрудники",
      "addEmployee": "Добавить сотрудника",
      "selectEmployee": "Выберите сотрудника",
      "verified": "Верифицирован",
      "errors": {
        "dateRangeError": "Дата начала не может быть больше даты окончания",
        "totalPrice": "Общая цена не может быть равна 0 или болше цены"
      },
      "unit": "Единица",
      "willUse": "Будет израсходовано"
    },
    "week": {
      "mon": "пн",
      "tue": "вт",
      "wed": "ср",
      "thu": "чт",
      "fri": "пт",
      "sat": "сб",
      "sun": "вс"
    },
    "months": {
      "january": "Январь",
      "february": "Февраль",
      "march": "Март",
      "april": "Апрель",
      "may": "Май",
      "june": "Июнь",
      "july": "Июль",
      "august": "Август",
      "september": "Сентябрь",
      "october": "Октябрь",
      "november": "Ноябрь",
      "december": "Декабрь"
    },
    "popup": {
      "employee": "Работник",
      "user": "Пользователь",
      "mobilePhone": "Мобильный телефон",
      "procedure": "Процедура",
      "price": "Цена",
      "discount": "Скидка",
      "times": "Время",
      "comment": "Комментарий",
      "bookedAt": "Забронировано",
      "bookedBy": "Забронировано",
      "completedBy": "Завершено",
      "status": "Статус",
      "balance": "Баланс",
      "source": "Источник",
      "additionalEmployee": "Доп. сотрудник",
      "room": "Комната",
      "paidAmount": "Оплачено"
    },
    "tooltip": {
      "calendar": "Календарь",
      "employeeCard": "Карточка сотрудника"
    },
    "menu": {
      "newVisit": "Новый визит",
      "employeeDay": "Календарь сотрудника",
      "block": "Заблокировать время",
      "blockConfirm": "Отметить весь день выходным для {{name}} ({{date}})?",
      "blockSuccess": "День отмечен как выходной"
    },
    "status": {
      "confirmed": "Подтверждено",
      "inProgress": "В процессе",
      "completed": "Завершено",
      "noShow": "Не явился"
    },
    "unknownClient": "Неизвестный",
    "notWorking": "Нерабочее",
    "saveError": "Не удалось сохранить изменения",
    "hold": {
      "tooltip": "Слот удержан для онлайн-оплаты — забронировать нельзя",
      "genericSource": "Онлайн-удержание",
      "ariaLabel": "Удержано через {{source}}, {{start}}–{{end}}, забронировать нельзя"
    },
    "pendingOnline": {
      "title": "Ожидает подтверждения (онлайн)",
      "tooltip": "Ожидает подтверждения — перейдите в Онлайн-бронирование, чтобы принять или отклонить",
      "overlapWarningTitle": "Этот слот пересекается с ожидающим онлайн-бронированием",
      "overlapWarningContent": "{{name}}, {{start}}–{{end}}, оплачено ₾{{paid}} из ₾{{total}}. Всё равно забронировать?",
      "overlapWarningConfirm": "Всё равно забронировать",
      "overlapWarningUnknownCustomer": "Клиент"
    },
    "confirmedOnline": {
      "label": "Онлайн"
    }
  },
  "recordings": {
    "start": "Начать",
    "finish": "Заканчивать",
    "deleted": "Удаленный",
    "status": "Статус",
    "service": "Сервись",
    "price": "Цена",
    "reservationTime": "Время резервации",
    "startingTime": "Время начала",
    "finishingTime": "Время окончания",
    "employee": "работник",
    "room": "Комната",
    "source": "Источник",
    "user": "Пользователь",
    "mobilePhone": "Мобильный телефон",
    "createdBy": "Создано",
    "created": "Созданный",
    "cancellationDate": "Дата отмены",
    "cancelledBy": "Отмененный",
    "cancellationReason": "Причина отмены",
    "download": "Скачать"
  },
  "statistic": {
    "detailSearch": {
      "operationSource": {
        "reservation": "Запись",
        "salary": "Зарплата ",
        "realization": "реализация",
        "expense": "Расходы",
        "purchase": "Покупка",
        "popOpBalance": "Пополните баланс",
        "returnBalance": "Возвратный баланс",
        "cashRegister": "Касса"
      },
      "operationType": {
        "procedure": "процедура",
        "specialProcedure": "Специальная процедура",
        "accrualSalary": "Начисление зарплаты",
        "salaryDisbursement": "Выплата зарплаты",
        "sell": "Продавать ",
        "spend": "Тратить ",
        "purchase": "Покупка ",
        "expense": "Расходы",
        "topUpBalance": "Пополните баланс",
        "spendBalance": "Потратьте остаток",
        "returnBalance": "Возвратный баланс"
      },
      "search": {
        "start": "Начать",
        "finish": "Заканчивать",
        "employee": "работник",
        "user": "Пользователь",
        "procedureCategory": "Категория процедуры",
        "category": "Категория",
        "procedure": "Процедура",
        "room": "Комната",
        "source": "Источник",
        "expenseCategory": "Категория расходов",
        "expenseSubCategory": "Подкатегория расходов",
        "sourceOperation": "Источник операции",
        "operationType": "Тип операции",
        "product": "продукт",
        "productCategory": "Категория продукта",
        "productProvider": "Поставщик продукта",
        "reservation": "Запись",
        "search": "Поиск",
        "clear": "очистить",
        "productCodeBarcode": "Код или Штрих-код продукта"
      },
      "column": {
        "operationNumber": "#",
        "date": "Дата",
        "sourceOperation": "Источник операции",
        "type": "Тип",
        "paymentMethod": "Способ оплаты",
        "service": "Сервись",
        "category": "Категория",
        "time": "Время",
        "user": "Пользователь",
        "price": "Цена",
        "discountPrice": "Цена со скидкой",
        "discount%": "% Скидки",
        "fixatedExpense": "Фиксированный расход",
        "specialProcedureExpense": "Расходы на спец-процедуру",
        "employee": "работник",
        "employeeSalary": "Зарплата",
        "expenseCategory": "категория расходов",
        "nameProduct": "Название продукта",
        "barcode": "Штрих-код",
        "provider": "Поставщик",
        "quantity": "Количество",
        "capacity": "Вместимость",
        "created": "Созданный",
        "createdBy": "Кто создал"
      },
      "detailView": {
        "user": "Пользователь",
        "created": "Созданный",
        "comment": "Комментарий",
        "employee": "работник",
        "createdBy": "Созданный",
        "sumTotal": "Общая сумма",
        "type": "Тип",
        "procedures": "процедуры",
        "reservationDate": "Дата резервации",
        "nameLastName": "Имя, Фамилия",
        "time": "Время",
        "price": "Цена",
        "position": "Позиция",
        "fixatedExpense": "Фиксированный расход",
        "additionalExpense": "Дополнительный расход",
        "discountPrice": "Цена со скидкой",
        "employee%": "% работника",
        "products": "Продукты",
        "barcode": "Штрих-код",
        "nameProduct": "Название продукта",
        "service": "Сервись",
        "capacity": "Вместимость",
        "quantity": "Количество",
        "salary": "Зарплата",
        "fixated%": "Зафиксированный %",
        "employeeSalary": "Зарплата",
        "transaction": "Операция",
        "transaction#": "# Операции",
        "transactionType": "Тип транзакции",
        "paymentMethod": "Способ оплаты",
        "cash": "Наличные",
        "card": "Карта",
        "bank": "Банк",
        "balance(GEL)": "Баланс (GEL)",
        "status": "Статус",
        "addAmount": "Добавляйте Сумму",
        "amount": "Сумма",
        "gel": "GEL",
        "salaryDisbursement": "Выплата зарплаты",
        "Products": "Продукты",
        "expenses": "расходы",
        "balance": "Баланс"
      }
    },
    "operation": {
      "operationSource": {
        "reservation": "Запись",
        "salary": "Зарплата ",
        "realization": "реализация",
        "expense": "Расходы",
        "purchase": "Покупка",
        "popOpBalance": "Пополните баланс",
        "returnBalance": "Возвратный баланс",
        "cashRegister": "Касса"
      },
      "search": {
        "start": "Начать",
        "finish": "Заканчивать",
        "operationNumber": "Номер операции",
        "sourceOperation": "Источник операции",
        "employee": "работник",
        "user": "Пользователь",
        "bank": "Банк"
      },
      "column": {
        "operationNumber": "#",
        "sourceOperation": "Источник операции",
        "paymentMethod": "Способ оплаты",
        "date": "Дата",
        "price": "Время",
        "cash": "Наличные",
        "card": "Карта",
        "bank": "Банк",
        "bankName": "Название банка",
        "balance": "Баланс(GEL)",
        "minutes": "Баланс(Минуты)",
        "user": "Пользователь",
        "employee": "работник",
        "createdBy": "создатель",
        "procedure": "Процедура",
        "created": "Созданный",
        "seeDetails": "Смотрите подробности",
        "barter": "Бартер"
      }
    },
    "transaction": {
      "search": {
        "start": "Начать",
        "finish": "Заканчивать",
        "paymentMethod": "Способ оплаты",
        "deleted": "удалены"
      },
      "column": {
        "transaction#": "# транз.",
        "date": "Дата",
        "created": "Созданный",
        "transactionType": "Тип транзакции",
        "paymentMethod": "Способ оплаты",
        "paid": "Оплачено",
        "cash": "Наличные",
        "card": "Карта",
        "bank": "Банк",
        "balance(GEL)": "Баланс (GEL)",
        "price": "Цена",
        "discountPrice": "Цена со скидкой",
        "discount%": "% Скидки",
        "fixatedExpense": "Фиксированный расход",
        "specialProcedureExpense": "Расходы на специальную процедуру",
        "comment": "Комментарий",
        "createdBy": "создатель",
        "transaction": "Операция",
        "user": "Пользователь"
      }
    },
    "consignation": {
      "consignmentCoverage": "Оплата консигнации",
      "paymentMethod": "Способ оплаты",
      "comment": "Комментарий",
      "search": {
        "start": "Начать",
        "finish": "Заканчивать",
        "user": "Пользователь",
        "status": "Статус",
        "toPaid": "должен быть оплачен",
        "paid": "Оплачено",
        "totalPayment": "Общая сумма платежа",
        "gel": "GEL"
      },
      "column": {
        "date": "Дата",
        "user": "Пользователь",
        "price": "Цена",
        "discountPrice": "Цена со скидкой",
        "ToPaid": "должен быть оплачен",
        "cash": "Наличные",
        "card": "Карта",
        "bank": "Банк",
        "consignment": "консигнация",
        "covered": "Покрыт",
        "status": "Статус",
        "employee": "работник",
        "created": "создатель",
        "issued": "должен быть оплачен",
        "paid": "Оплачено"
      },
      "title": "Консигнация"
    }
  },
  "profitLoss": {
    "search": {
      "start": "Начать",
      "finish": "Заканчивать"
    },
    "column": {
      "date": "Дата",
      "income": "Доход",
      "cash": "Наличные ",
      "cashless": "Безналичный",
      "fixatedExpense": "Фиксированный расход",
      "expense": "Расходы",
      "expenseCash": "Расходы наличными",
      "cashlessExpense": "Безналичный расход",
      "salaries": "Зарплаты",
      "otherExpenses": "Прочие расходы",
      "profit": "Прибыль",
      "profitFixatedExpense": "Расходы, фиксированные на прибыли",
      "addMoney": "Добавить деньги в кассу",
      "subMoney": "Снять деньги из кассы"
    }
  },
  "diagrams": {
    "graphicDiagrams": "Графические диаграммы",
    "incomeProcedures": "Доход с помощью процедур",
    "incomeCategories": "Доход по категориям",
    "clients": "Клиенты",
    "products": "Продукты",
    "start": "Начать",
    "finish": "Заканчивать",
    "procedure": "Процедура",
    "sumTotal": "Общая сумма",
    "quantity": "Количество",
    "categoriesIncome": "Доход Категории процедур",
    "procedureCategory": "Категория процедуры"
  },
  "expense": {
    "expenseType": "Тип расходов",
    "category": "Категория",
    "toPaid": "Подлежащий оплате",
    "amount": "Сумма",
    "viaBank": "Через банк",
    "comment": "Укажите комментарий",
    "issueExpense": "Оформить расход",
    "expenseCategories": "Категории расходов",
    "addExpense": "Добавить расходы",
    "nameExpense": "Название расхода",
    "subCategory": "Подкатегория",
    "expenseProcessing": "Обработка расхода",
    "addSubCategory": "Подкатегория",
    "date": "дата расхода",
    "close": "Закрыть",
    "paymentMethod": {
      "label": "Способ оплаты",
      "cash": "Наличные",
      "card": "Карта",
      "transfer": "Перевод"
    },
    "bank": "Банк",
    "total": "Итого",
    "payableTotal": "Сумма к оплате",
    "issueSuccess": "Расход успешно проведён",
    "noSubcategory": "Подкатегория не добавлена",
    "required": "Заполнение обязательно",
    "viewDeleted": "Показать удалённые",
    "deleted": "Удалён"
  },
  "booking": {
    "productExpense": "Расход на продукты",
    "additionalExpense": "Дополнительный расход",
    "totalExpense": "Общий расход"
  },
  "marketing": {
    "reminder": {
      "created": "Напоминание создано",
      "user": "Пользователь",
      "serviceCategory": "Категория услуг",
      "lastVisit": "Последний визит",
      "reminderPeriod": "Период напоминания",
      "remindDate": "Дата напоминания",
      "isSent": "Отправлено"
    },
    "smsHistory": {
      "search": {
        "start": "Начать",
        "finish": "Заканчивать",
        "sender": "Отправитель",
        "receiver": "Приемник",
        "user": "Пользователь",
        "reminderSource": "Источник напоминания"
      },
      "created": "Созданный",
      "smsType": "Тип SMS-сообщения",
      "sender": "Отправитель",
      "receiver": "Приемник",
      "user": "Пользователь",
      "reminderSource": "Источник напоминания",
      "reminderPeriod": "Период напоминания",
      "notification": "сообщения"
    },
    "smsTemplate": {
      "yourTemplate": "Ваш шаблон",
      "addTemplateEdit": "Добавить шаблон/редактировать",
      "addTemplate": "Добавить шаблон",
      "branchConfig": "Конфигурация филиала",
      "advancedSmsEnabled": "Расширенный SMS",
      "defaultLanguage": "Язык по умолчанию",
      "reminderOffsets": "Время напоминания",
      "eventEnabled": "Включено",
      "previewTest": "Предпросмотр / Тест",
      "language": "Язык",
      "preview": "Предпросмотр",
      "noPreview": "Предпросмотр недоступен",
      "testPhone": "Телефон",
      "sendTest": "Отправить тест",
      "configSaved": "Настройки сохранены",
      "eventToggled": "Событие обновлено",
      "testSentOk": "Тестовое SMS отправлено",
      "testSentFail": "Не удалось отправить тестовое SMS",
      "saveFailed": "Не удалось сохранить",
      "toggleError": "Не удалось обновить статус",
      "title": "SMS-уведомления",
      "subtitle": "Управляйте SMS-уведомлениями этого филиала: на какие события они отправляются, на каком языке и по какому шаблону.",
      "statusOn": "Вкл",
      "statusOff": "Выкл",
      "event": "Событие",
      "languages": "Языки",
      "hasOverride": "Задан шаблон филиала",
      "usesDefault": "Используется текст по умолчанию",
      "noEvents": "События не найдены",
      "systemDefault": "Текст сообщения",
      "branchOverride": "Ваш вариант",
      "insertField": "Вставить поле:",
      "chars": "симв.",
      "reminderOffsetsHelp": "Укажите, за сколько минут до визита отправить напоминание (например, 1440 — за 1 день, 120 — за 2 часа).",
      "defaultLanguageHelp": "На этом языке отправляется SMS, если предпочитаемый язык клиента неизвестен.",
      "advancedSmsEnabledHelp": "Включает собственную SMS-систему филиала: шаблоны по языкам, включение и отключение событий, настройка времени напоминаний.",
      "remindersHeading": "Напоминания о визите",
      "fixedReminderLabel": "За 1 день, в 17:00 (всегда включено)",
      "additionalReminderLabel": "Дополнительное напоминание перед визитом",
      "additionalReminderHelp": "При желании отправляйте ещё одно напоминание за заданное время до визита.",
      "unitMinutes": "минуты",
      "unitHours": "часы",
      "reminderRange": "Напоминание должно быть от 5 минут до 1 дня.",
      "clearReminder": "Очистить"
    },
    "birthday": {
      "title": "Дни рождения",
      "subtitle": "У кого скоро день рождения. Автоматическое поздравление отправляется только в сам день, а вручную его можно отправить в любой день.",
      "range": "Период",
      "branch": "Филиал",
      "allBranches": "Все филиалы",
      "customer": "Клиент",
      "birthDate": "День рождения",
      "daysLeft": "Осталось дней",
      "phone": "Телефон",
      "lastBranch": "Филиал",
      "statusColumn": "Статус",
      "greetedToday": "поздравлен",
      "notGreeted": "ещё не поздравлен",
      "today": "сегодня",
      "inDays": "через {{n}} дн.",
      "todayGroup": "Сегодня",
      "upcomingGroup": "Предстоящие",
      "noneToday": "Сегодня ни у кого нет дня рождения.",
      "manualRule": "Ручная отправка возможна в любой день. Автоматическое поздравление уходит только в день рождения.",
      "loadFailed": "Не удалось загрузить список",
      "sendSelected": "Отправить поздравление",
      "confirmTitle": "Отправить {{count}} клиентам?",
      "confirmTemplate": "Шаблон: {{template}}",
      "confirmRepeat": "Шаблон: {{template}}. Из них {{count}} уже получили поздравление за последний год.",
      "templatePlaceholder": "Шаблон",
      "noTemplates": "Шаблонов нет — создайте в настройках",
      "featureDisabledHint": "Поздравления с днём рождения выключены — включите в настройках",
      "sendFailedGeneric": "Не удалось отправить",
      "greetedOn": "поздравлен — {{date}}",
      "status": {
        "SENT": "отправлено",
        "ALREADY_SENT": "сегодня уже поздравили",
        "NO_PHONE": "нет номера телефона",
        "NO_BRANCH": "филиал не определён",
        "NO_SENDER": "у филиала нет отправителя SMS",
        "NO_TEMPLATE": "нет активного шаблона на этом языке",
        "NOT_ELIGIBLE": "не подходит (нет даты рождения, нет номера телефона или не является клиентом этой организации)",
        "FAILED": "ошибка"
      },
      "config": {
        "title": "Настройка дней рождения",
        "subtitle": "Настройки автоматических поздравлений и шаблоны. Настройки действуют на всю организацию.",
        "isActive": "Автоматическая отправка",
        "isActiveHint": "После включения поздравления отправляются автоматически каждый день",
        "stateOn": "включено",
        "stateOff": "выключено",
        "sendHour": "Час отправки",
        "sendHourHint": "По тбилисскому времени, от 0 до 23",
        "sendHourError": "Укажите час от 0 до 23",
        "minVisits": "Минимум визитов",
        "minVisitsHint": "Клиент с меньшим числом визитов не поздравляется",
        "minVisitsError": "Минимум 1",
        "save": "Сохранить",
        "saved": "Сохранено",
        "saveFailed": "Не удалось сохранить",
        "confirmTitle": "Включить автоматическую отправку",
        "confirmBody": "Каждый день в {{hour}}:00 по тбилисскому времени всем подходящим клиентам всей организации автоматически отправляется SMS. Каждое сообщение платное.",
        "confirmOk": "Включить"
      },
      "template": {
        "title": "Шаблоны",
        "add": "Добавить шаблон",
        "edit": "Редактировать шаблон",
        "editAction": "Редактировать",
        "name": "Название",
        "nameError": "Название обязательно",
        "language": "Язык",
        "message": "Текст",
        "messageError": "Текст обязателен",
        "isDefault": "По умолчанию",
        "isActive": "Активен",
        "active": "активен",
        "inactive": "выключен",
        "defaultWarning": "Для этого языка уже есть шаблон по умолчанию. При сохранении он будет выключен.",
        "save": "Сохранить",
        "cancel": "Отмена",
        "saved": "Сохранено",
        "saveFailed": "Не удалось сохранить",
        "loadFailed": "Не удалось загрузить шаблоны"
      },
      "widget": {
        "title": "Дни рождения",
        "seeAll": "Весь список",
        "today": "Сегодня",
        "tomorrow": "Завтра",
        "week": "На следующей неделе",
        "none": "На ближайшей неделе дней рождения нет.",
        "failed": "Не удалось загрузить дни рождения."
      }
    }
  },
  "MassiveUploadProcedures": {
    "title": "Массовая загрузка процедур",
    "p1": "При добавлении процедуры необходимо, чтобы загруженная информация была введена в уже подготовленный файл Excel, шаблон которого можно загрузить, нажав на кнопку “шаблон”",
    "p2": "Перетащите название процедур из ваших файлов в указанную форму вместе с другой информацией и загрузите ее в систему",
    "p3": "Пожалуйста, обратите внимание, что категория, поставщик и название продукта поставщика должны на 100% соответствовать существующей записи в программе и той, которая указана вами в Excel, в противном случае в программном обеспечении будет создана новая категория поставщика и продукта поставщика."
  },
  "massiveUploadProduct": {
    "title": "Массовая загрузка продукта с файлом",
    "p1": "При загрузке продукта необходимо, чтобы ваши остатки были введены в уже подготовленную форму Excel, шаблон которой можно загрузить, нажав на кнопку 'Загрузить шаблон'",
    "p2": "Перетащите информацию о продуктах из ваших файлов в указанный файл и загрузите его в систему.",
    "p3": "Пожалуйста, обратите внимание, что название поставщика и категория должны на 100% совпадать между записью, уже имеющейся в программе, и записью, указанной вами в Excel, в противном случае в программном обеспечении будет создана новая категория или поставщик."
  },
  "massiveUploadUser": {
    "title": "Массовая загрузка пользователя файлом",
    "p1": "При загрузке базы клиентов необходимо, чтобы их информация была введена в уже подготовленную форму Excel, шаблон которой можно загрузить, нажав на кнопку \"Загрузить шаблон\". ",
    "p2": "Перетащите информацию о клиенте из ваших файлов в в указанный файл и загрузите его в систему.",
    "p3": "Пожалуйста, обратите внимание, что информация должна на 100% соответствовать названию полей."
  },
  "validators": {
    "percentRange": "Процент должен быть от 0 до 100",
    "required": "Указание обязательно",
    "personalId11Digits": "Личный номер должен состоять ровно из 11 цифр",
    "email": "Введите действительный адрес электронной почты",
    "minTimeRequired": "Указание минимального времени является обязательным",
    "PleaseEnterUser": "Пожалуйста, введите имя пользователя",
    "PleaseEnterPassword": "Пожалуйста, введите действительный пароль",
    "incorrectUsername": "Неверное имя пользователя",
    "incorrectPassword": "Неверный пароль",
    "indicateCurrentPassword": "Введите текущий пароль!",
    "indicateNewPassword": "Укажите новый пароль!",
    "repeatedPasswordMandatory": "Указание повторного пароля является обязательным",
    "passwordMatch": "Пароль не совпадает",
    "nextDayCashbox": "касса не может быть открыта На следующий день",
    "sureCloseDayYesNo": "Вы действительно хотите завершить день?Да/нет"
  },
  "notifications": {
    "indicationMandatory": "Указание обязательно",
    "minTimeRequired": "Указание минимального времени является обязательным",
    "PleaseEnterUser": "Пожалуйста, введите имя пользователя",
    "PleaseEnterPassword": "Пожалуйста, введите действительный пароль",
    "incorrectUsername": "Неверное имя пользователя",
    "incorrectPassword": "Неверный пароль",
    "indicateCurrentPassword": "Введите текущий пароль!",
    "indicateNewPassword": "Укажите новый пароль!",
    "repeatedPasswordMandatory": "Указание повторного пароля является обязательным",
    "passwordMatch": "Пароль не совпадает",
    "nextDayCashbox": "касса не может быть открыта На следующий день",
    "sureCloseDayYesNo": "Вы действительно хотите завершить день?Да/нет"
  },
  "buttons": {
    "newRecord": "новая запись",
    "cancel": "Отмена",
    "withFile": "Добавить с помощью файла",
    "download": "Скачать",
    "save": "сохранить",
    "create": "Создать",
    "view": "Просмотр",
    "close": "Закрыть",
    "deletePop": "Вы уверены, что хотите удалить?",
    "massiveUpload": "Массовая загрузка",
    "edit": "редактировать",
    "delete": "Удалить",
    "update": "Обновление",
    "search": "поиск",
    "updateHistory": "История обновлений",
    "stockAccounting": "Учет запасов",
    "pay": "Оплатить",
    "template": "Шаблон",
    "chooseFile": "Выберите файл",
    "upload": "Загружать",
    "finishPop": "Вы уверены, что хотите завершить?",
    "finish": "Заканчивать",
    "clear": "очистить",
    "add": "Добавить"
  },
  "search": {
    "searchWord": "Поисковое слово",
    "category": "Категория",
    "distributor": "Распространитель"
  },
  "specifyingNeccessary": "Указание обязательно",
  "findReservation": {
    "reservation": "резервация",
    "employee": "работник",
    "user": "Пользователь",
    "phoneNumber": "Номер телефона",
    "procedure": "Процедура",
    "price": "Цена",
    "gel": "GEL"
  },
  "organization": {
    "name": "Название",
    "subdomain": "Веб-сайт",
    "legalName": "Юридическое название",
    "orgPrefix": "Префикс организации",
    "registrationNumber": "Регистрационный номер",
    "physicalAddress": "Физический адрес",
    "legalAddress": "Юридический адрес",
    "mobile": "Мобильный Директора",
    "phone": "Мобильный Фильиала",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "webpage": "Веб-сайт",
    "description": "Описание",
    "email": "Эл. адрес",
    "update": "Обновление",
    "printConfig": {
      "title": "Печать: заголовок и подвал",
      "configure": "Настроить",
      "saved": "Настройки печати сохранены",
      "headerLogo": "Логотип заголовка",
      "uploadLogo": "Загрузить логотип",
      "headerTitle": "Заголовок",
      "headerTitlePlaceholder": "Компания / название документа",
      "footerLine1": "Подвал, строка 1",
      "footerLine1Placeholder": "Адрес, телефон и т.д.",
      "footerLine2": "Подвал, строка 2",
      "footerLine2Placeholder": "Сайт, эл. почта и т.д.",
      "showPageNumbers": "Показывать номера страниц",
      "inherited": "Унаследовано от организации",
      "resetToOrg": "Сбросить к настройкам организации",
      "savePrintConfig": "Сохранить настройки печати",
      "signatureImage": "Изображение подписи",
      "uploadSignature": "Загрузить подпись"
    }
  },
  "bookinghub": {
    "activate": {
      "title": "Bookinghub.ge გააქტიურება",
      "description": "გთხოვთ შეიყვანოთ თქვენი მობილური ნომერი და პაროლი რომლის საფუძველზეა გსურთ გააქტიუროთ Bookinghub.ge სერვისი",
      "mobilePhone": "მობილური ნომერი",
      "password": "პაროლი"
    }
  },
  "onlineCatalog": {
    "title": "BookingHub услугами",
    "subtitle": "Управление онлайн услугами для BookingHub",
    "branchServices": "Услуги филиала",
    "addService": "Добавить услугу",
    "editService": "Редактировать услугу",
    "serviceName": "Название услуги",
    "category": "Категория",
    "price": "Цена",
    "duration": "Длительность",
    "employees": "Сотрудники",
    "status": "Статус",
    "noServicesConfigured": "Онлайн услуги не настроены",
    "addFirstService": "Добавить первую услугу",
    "selectService": "Выберите услугу",
    "selectServicePlaceholder": "Найдите и выберите услугу из каталога",
    "suggestedPrice": "Рекомендуемая цена",
    "suggestedDuration": "Рекомендуемая длительность",
    "from": "от",
    "upTo": "до",
    "minutes": "минут",
    "serviceAdded": "Услуга успешно добавлена",
    "serviceUpdated": "Услуга успешно обновлена",
    "serviceDeleted": "Услуга успешно удалена",
    "serviceActivated": "Услуга активирована",
    "serviceDeactivated": "Услуга деактивирована",
    "confirmDelete": "Вы уверены, что хотите удалить эту услугу?",
    "assignEmployees": "Назначить сотрудников",
    "noEmployees": "Сотрудники не назначены",
    "employeesCount": "сотрудников",
    "employeeName": "Имя сотрудника",
    "position": "Должность",
    "customPrice": "Индивидуальная цена",
    "customDuration": "Индивидуальная длительность",
    "defaultPrice": "Стандартная цена",
    "defaultDuration": "Стандартная длительность",
    "selectedEmployees": "Выбранные сотрудники",
    "employeesAssigned": "Сотрудники успешно назначены",
    "noEmployeesAvailable": "Сотрудники не найдены",
    "bulkAddServices": "Массовое добавление услуг",
    "searchServices": "Поиск услуг...",
    "selectAll": "Выбрать все",
    "selectedCount": "Выбрано",
    "addSelected": "Добавить выбранное",
    "selectAtLeastOneService": "Пожалуйста, выберите хотя бы одну услугу",
    "servicesAddedCount": "{{count}} услуг успешно добавлено",
    "servicesSkippedCount": "{{count}} услуг пропущено (уже добавлены)",
    "noServicesFound": "Услуги не найдены",
    "startTime": "Время начала",
    "endTime": "Время окончания",
    "searchEmployee": "Поиск по имени или должности",
    "searchService": "Поиск услуги...",
    "allCategories": "Все категории",
    "requestService": "Запросить услугу",
    "serviceRequest": {
      "title": "Запрос новой услуги",
      "description": "Если вы не можете найти нужную услугу или категорию в каталоге, вы можете отправить запрос, и мы рассмотрим возможность её добавления.",
      "type": "Тип",
      "typePlaceholder": "Выберите тип",
      "typeService": "Услуга",
      "typeCategory": "Категория",
      "name": "Название",
      "namePlaceholder": "Введите название желаемой услуги или категории",
      "success": "Запрос успешно отправлен",
      "error": "Не удалось отправить запрос"
    }
  },
  "notification": {
    "permission_denied": "Вы заблокировали уведомления. Включите уведомления в настройках браузера, чтобы получать обновления.",
    "permission_default": "Вы еще не разрешили уведомления. Пожалуйста, разрешите уведомления в настройках браузера, чтобы получать обновления.",
    "permission_request": "Включить уведомления"
  },
  "ALERT": {
    "important_info": "Важная информация"
  },
  "ehrTemplate": {
    "title": "Шаблоны электронных медицинских записей",
    "createButton": "Создать шаблон",
    "searchPlaceholder": "Поиск по названию или описанию",
    "noData": "Шаблоны не найдены",
    "active": "Активный",
    "inactive": "Неактивный",
    "general": "Общий",
    "custom": "Индивидуальный",
    "viewTooltip": "Просмотр шаблона",
    "editTooltip": "Редактировать шаблон",
    "deleteTooltip": "Удалить шаблон",
    "deleteConfirm": "Вы уверены, что хотите удалить этот шаблон?",
    "columns": {
      "name": "Название",
      "description": "Описание",
      "isActive": "Статус",
      "isGeneral": "Тип",
      "createdAt": "Создано",
      "updatedAt": "Обновлено"
    },
    "form": {
      "title": "Шаблон электронной медицинской записи",
      "createTitle": "Создать шаблон",
      "editTitle": "Редактировать шаблон",
      "viewTitle": "Просмотр шаблона",
      "name": "Название шаблона",
      "namePlaceholder": "Введите название шаблона",
      "nameError": "Название шаблона обязательно",
      "description": "Описание",
      "descriptionPlaceholder": "Введите описание шаблона",
      "descriptionError": "Описание слишком длинное",
      "content": "Содержание шаблона",
      "contentPlaceholder": "Введите содержание шаблона в формате JSON",
      "contentError": "Неверный формат содержания",
      "isActive": "Активный статус",
      "isGeneral": "Общий шаблон",
      "cancel": "Отмена",
      "create": "Создать",
      "update": "Обновить",
      "close": "Закрыть"
    }
  },
  "locale": {
    "ka": "Грузинский",
    "en": "Английский",
    "ru": "Русский"
  },
  "userStatus": {
    "add-or-edit": "Добавить/Редактировать статус",
    "active": "Активный",
    "inactive": "Неактивный",
    "name": "Название",
    "description": "Описание"
  },
  "userSource": {
    "title": "Источники пользователей",
    "name": "Название",
    "namePlaceholder": "Введите название источника",
    "type": "Тип",
    "status": "Статус",
    "createdAt": "Создано",
    "global": "Глобальный",
    "custom": "Пользовательский",
    "active": "Активный",
    "inactive": "Неактивный",
    "readOnly": "Только чтение",
    "add": "Добавить источник",
    "edit": "Редактировать источник",
    "search": "Поиск"
  },
  "REPORTS": {
    "VISITS": {
      "DATE_FROM": "Date from",
      "DATE_TO": "Date to",
      "STATUS": "Status",
      "SEARCH_NAME": "Search name",
      "SEARCH": "Search",
      "RESET": "Reset",
      "EXPORT": "Export",
      "ID": "ID",
      "VISIT_DATE": "Visit Date",
      "FULL_NAME": "Full Name",
      "TOTAL_PAID": "Total Paid",
      "STATUS_COL": "Status",
      "ACTIONS": "Actions",
      "DOWNLOAD_INVOICE": "Download invoice",
      "STATUS_VALUES": {
        "PENDING": "Pending",
        "CONFIRMED": "Confirmed",
        "IN_PROGRESS": "In Progress",
        "COMPLETED": "Completed",
        "CANCELED": "Canceled",
        "DELETED": "Deleted"
      }
    }
  },
  "serverErrors": {
    "INSUFFICIENT_BALANCE": "Недостаточно средств на балансе для оплаты",
    "INSUFFICIENT_MINUTES": "Недостаточно минут для оплаты",
    "INVALID_SALARY_AMOUNT": "Неверная сумма зарплаты",
    "signature-pad-disabled": "Планшет для подписи не включён для этого филиала.",
    "Insufficient permissions": "У вас нет прав на это действие"
  },
  "addVisit": {
    "buttons": {
      "saveVisit": "შენახვა",
      "cancel": "ვიზიტის გაუქმება",
      "addService": "პროცედურის დამატება",
      "addProduct": "პროდუქტის დამატება",
      "continue": "გაგრძელება",
      "close": "დახურვა",
      "savePayment": "გადახდა"
    },
    "form": {
      "isAnonymous": "უცნობი მომხმარებელი",
      "anonymousName": "მომხმარებელი სახელი",
      "withOutService": "პროცედურა გარეშე",
      "sendNotification": "შეტყობინების გაგზავნა",
      "sendToMobile": "მობილურზე გაგზავნა"
    },
    "sendRecipe": {
      "title": "საგადახდო ქვითრის გაგზავნა",
      "success": "წარმატებით გაიგზავნა",
      "error": "გაგზავნისას მოხდა შეცდომა",
      "successMessage": "საგადახდო ქვითარი წარმატებით გაიგზავნა",
      "errorMessage": "საგადახდო ქვითრის გაგზავნისას მოხდა შეცდომა"
    },
    "errors": {
      "paymentTitle": "გადახდის შეცდომა",
      "totalPriceMismatch": "გადახდის ჯამი უნდა ემთხვეოდეს საერთო თანხას",
      "deletedServiceTitle": "Нельзя завершить визит",
      "deletedServiceContent": "Эти услуги удалены: {{names}}. Замените или удалите их в визите, затем завершите его."
    }
  },
  "room": {
    "title": "Управление кабинетами",
    "createButton": "Создать кабинет",
    "dragToReorder": "Перетащите строки для изменения порядка",
    "active": "Активный",
    "inactive": "Неактивный",
    "visible": "Видимый",
    "hidden": "Скрытый",
    "multiEmployee": "Несколько сотрудников",
    "singleEmployee": "Один сотрудник",
    "unlimited": "Без ограничений",
    "viewTooltip": "Просмотр деталей кабинета",
    "editTooltip": "Редактировать кабинет",
    "deleteTooltip": "Удалить кабинет",
    "deleteConfirm": "Вы уверены, что хотите удалить этот кабинет?",
    "columns": {
      "name": "Название",
      "description": "Описание",
      "isActive": "Активный",
      "visibleInCalendar": "Видимость в календаре",
      "canWorkMultipleEmployees": "Несколько сотрудников",
      "maxParallelBookings": "Параллельные бронирования",
      "order": "Порядок",
      "createdAt": "Создано",
      "actions": "Действия"
    },
    "form": {
      "name": "Название кабинета",
      "namePlaceholder": "Введите название кабинета",
      "nameError": "Пожалуйста, введите название кабинета",
      "description": "Описание",
      "descriptionPlaceholder": "Введите описание кабинета",
      "order": "Порядок отображения",
      "orderPlaceholder": "Введите порядок отображения",
      "orderError": "Порядок должен быть 0 или больше",
      "isActive": "Активный",
      "visibleInCalendar": "Видимый в календаре",
      "canWorkMultipleEmployees": "Разрешить нескольких сотрудников",
      "maxParallelBookings": "Макс. параллельных бронирований",
      "maxParallelBookingsHint": "0 = без ограничений, 1 = одно бронирование, N = максимальное количество"
    },
    "view": {
      "tabs": {
        "info": "Информация и Статистика",
        "services": "Услуги Кабинета",
        "scheduler": "Расписание"
      },
      "info": {
        "details": "Детали Кабинета",
        "statistics": "Статистика",
        "totalRevenue": "Общий Доход",
        "totalBookings": "Всего Бронирований",
        "completedVisits": "Завершенные Визиты",
        "pendingVisits": "Ожидающие Визиты",
        "assignedServices": "Назначенные Услуги",
        "scheduledDays": "Запланированные Дни",
        "displayOrder": "Порядок Отображения"
      },
      "services": {
        "title": "Назначенные Услуги",
        "serviceName": "Название Услуги",
        "serviceCategory": "Категория",
        "assignedDate": "Дата Назначения",
        "actions": "Действия",
        "addButton": "Добавить Услугу",
        "removeTooltip": "Удалить Услугу",
        "removeConfirm": "Вы уверены, что хотите удалить эту услугу из кабинета?",
        "noServices": "Нет услуг, назначенных этому кабинету",
        "searchPlaceholder": "Поиск услуг...",
        "selectCategories": "Выберите категории услуг для фильтрации",
        "servicesSelected": "услуг выбрано"
      },
      "scheduler": {
        "title": "Расписание Кабинета",
        "date": "Дата",
        "shiftStart": "Начало Смены",
        "shiftEnd": "Конец Смены",
        "status": "Статус",
        "breaks": "Перерывы",
        "actions": "Действия",
        "addButton": "Добавить Расписание",
        "deleteTooltip": "Удалить Расписание",
        "noSchedules": "Расписание не найдено",
        "startDate": "Дата Начала",
        "endDate": "Дата Окончания",
        "status_AVAILABLE": "Доступен",
        "status_UNAVAILABLE": "Недоступен",
        "status_MAINTENANCE": "Техническое Обслуживание",
        "planButton": "Запланировать Расписание",
        "planTooltip": "Выберите даты в календаре для планирования расписания",
        "selectDates": "Пожалуйста, выберите даты в календаре"
      }
    }
  },
  "common": {
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "noData": "Нет данных",
    "month": "Месяц",
    "year": "Год",
    "uploading": "Загрузка...",
    "yes": "Да",
    "no": "Нет",
    "days": "дней",
    "actions": "Действия",
    "edit": "Редактировать",
    "error": "Ошибка",
    "save": "Сохранить",
    "add": "Добавить",
    "submit": "Отправить"
  },
  "bookingSources": {
    "title": "Источники Бронирования",
    "addButton": "Добавить Источник",
    "createTitle": "Новый Источник",
    "editTitle": "Редактировать Источник",
    "confirmDelete": "Вы уверены, что хотите удалить этот источник?",
    "table": {
      "icon": "Иконка",
      "name": "Название",
      "status": "Статус",
      "actions": "Действия"
    },
    "form": {
      "name": "Название Источника",
      "namePlaceholder": "Введите название источника",
      "nameError": "Пожалуйста, введите название источника",
      "icon": "Иконка",
      "iconPlaceholder": "Введите иконку (эмодзи)",
      "iconHelp": "Введите эмодзи или идентификатор иконки"
    },
    "messages": {
      "createSuccess": "Источник успешно создан",
      "updateSuccess": "Источник успешно обновлен",
      "deleteSuccess": "Источник успешно удален",
      "createError": "Не удалось создать источник",
      "editError": "Не удалось обновить источник",
      "deleteError": "Не удалось удалить источник",
      "toggleError": "Не удалось изменить статус",
      "activateSuccess": "Источник активирован",
      "deactivateSuccess": "Источник деактивирован"
    },
    "actions": {
      "edit": "Редактировать",
      "delete": "Удалить"
    },
    "status": {
      "active": "Активен",
      "inactive": "Неактивен"
    }
  },
  "service": {
    "price": "Цена",
    "duration": "Продолжительность"
  },
  "offers": {
    "title": "Предложения",
    "types": {
      "fullPayment": "Полная оплата",
      "partialPayment": "Частичная оплата"
    },
    "categories": {
      "offer": "Предложение",
      "package": "Пакет"
    },
    "activationMethods": {
      "fixedPeriod": "Фиксированный период",
      "onPurchase": "При покупке",
      "manual": "Ручная активация"
    },
    "status": {
      "active": "Активный",
      "running": "В процессе",
      "completed": "Завершен",
      "cancelled": "Отменен"
    },
    "filters": {
      "search": "Поиск предложений...",
      "status": "Статус",
      "branch": "Филиал",
      "startDate": "Дата начала",
      "endDate": "Дата окончания",
      "category": "Категория",
      "internalSale": "Внутренняя продажа"
    },
    "columns": {
      "image": "Изображение",
      "name": "Название",
      "category": "Категория",
      "price": "Цена",
      "quantity": "Количество",
      "dates": "Даты",
      "status": "Статус",
      "platforms": "Платформы",
      "actions": "Действия",
      "service": "Услуга",
      "onlineService": "Онлайн-услуга",
      "employees": "Сотрудники",
      "qty": "Кол-во",
      "originalPrice": "Начальная цена",
      "discountedPrice": "Цена со скидкой"
    },
    "labels": {
      "sale": "Продажа",
      "valid": "Действителен",
      "cover": "Обложка",
      "totalOriginal": "Итого начальная",
      "totalDiscounted": "Итого со скидкой",
      "discount": "Скидка",
      "internalSale": "Внутренняя",
      "serviceNumber": "Услуга"
    },
    "buttons": {
      "create": "Создать предложение",
      "viewStats": "Статистика покупок",
      "viewAnalytics": "Аналитика",
      "actions": "Действия",
      "duplicate": "Дублировать",
      "publishBookingHub": "Опубликовать на BookingHub",
      "unpublishBookingHub": "Снять с BookingHub",
      "deactivate": "Деактивировать предложение",
      "delete": "Удалить",
      "addService": "Добавить услугу",
      "uploadImage": "Загрузить изображение",
      "setCover": "Установить как обложку"
    },
    "tabs": {
      "basicInfo": "Основная информация",
      "translations": "Переводы",
      "services": "Услуги",
      "onlineServices": "Онлайн-услуги",
      "dates": "Даты",
      "branches": "Филиалы",
      "branch": "Филиал",
      "images": "Изображения",
      "settings": "Настройки"
    },
    "form": {
      "createTitle": "Создать предложение",
      "editTitle": "Редактировать предложение",
      "category": "Категория",
      "frontName": "Публичное название",
      "frontNamePlaceholder": "Название для клиентов",
      "frontNameHint": "Это название будет отображаться клиентам на платформах бронирования",
      "name": "Внутреннее название",
      "namePlaceholder": "Внутреннее справочное название",
      "description": "Описание",
      "descriptionPlaceholder": "Опишите, что включает это предложение...",
      "totalQuantity": "Общее количество",
      "pricePlaceholder": "Укажите количество",
      "offerType": "Тип предложения",
      "services": "Включенные услуги",
      "selectService": "Выберите услугу",
      "selectOnlineService": "Выберите онлайн-услугу",
      "selectEmployees": "Выберите сотрудников",
      "salePeriod": "Период продажи",
      "salePeriodHint": "Период, в течение которого можно приобрести это предложение",
      "activationDate": "Начало продажи",
      "endDate": "Окончание продажи",
      "validityPeriod": "Срок действия",
      "validityPeriodHint": "Период, в течение которого можно использовать предложение",
      "validityStartDate": "Действителен с",
      "expiryDate": "Действителен до",
      "branches": "Доступные филиалы",
      "selectBranches": "Выберите филиалы",
      "branchesHint": "Выберите филиалы, где можно использовать это предложение",
      "branch": "Филиал",
      "selectBranch": "Выберите филиал",
      "branchHint": "Сначала выберите филиал, затем сможете выбрать онлайн-сервисы и сотрудников",
      "imagesHint": "Загрузите минимум 5 изображений для предложения",
      "minimum": "минимум",
      "notifyMerchant": "Уведомить продавца при продаже",
      "notifyMerchantHint": "Отправить уведомление при продаже предложения",
      "bookingHubCategory": "ID категории BookingHub",
      "bookingHubCategoryPlaceholder": "Введите ID категории",
      "bookingHubCategoryHint": "ID категории для платформы BookingHub",
      "packageSettings": "Настройки пакета",
      "activationMethod": "Метод активации",
      "activationMethodHint": "Как пакет активируется после покупки",
      "activeDays": "Активных дней",
      "activeDaysPlaceholder": "Количество дней",
      "activeDaysHint": "Сколько дней действует пакет после активации",
      "allowInternalSale": "Разрешить внутреннюю продажу",
      "allowInternalSaleHint": "Включить внутреннюю продажу этого пакета в филиале"
    },
    "messages": {
      "created": "Предложение успешно создано",
      "updated": "Предложение успешно обновлено",
      "deleted": "Предложение успешно удалено",
      "duplicated": "Предложение успешно дублировано",
      "deactivated": "Предложение успешно деактивировано",
      "published": "Предложение опубликовано на BookingHub",
      "unpublished": "Предложение снято с BookingHub",
      "loadError": "Не удалось загрузить предложение",
      "saveError": "Не удалось сохранить предложение",
      "deleteError": "Не удалось удалить предложение",
      "duplicateError": "Не удалось дублировать предложение",
      "deactivateError": "Не удалось деактивировать предложение",
      "publishError": "Не удалось опубликовать предложение",
      "unpublishError": "Не удалось снять предложение",
      "uploadError": "Не удалось загрузить изображение",
      "noServices": "Услуги еще не добавлены. Нажмите 'Добавить услугу', чтобы включить услуги в это предложение."
    },
    "validation": {
      "minServices": "Пожалуйста, добавьте хотя бы одну услугу",
      "minImages": "Пожалуйста, загрузите минимум 5 изображений"
    },
    "confirm": {
      "deactivate": "Вы уверены, что хотите деактивировать это предложение?",
      "delete": "Вы уверены, что хотите удалить это предложение?"
    }
  },
  "offerStats": {
    "title": "Покупки предложений",
    "status": {
      "active": "Активный",
      "used": "Использован",
      "cancelled": "Отменен"
    },
    "filters": {
      "search": "Поиск по имени, телефону, ID...",
      "status": "Статус",
      "source": "Источник",
      "branch": "Филиал",
      "offer": "Предложение",
      "startDate": "Дата начала",
      "endDate": "Дата окончания"
    },
    "columns": {
      "externalId": "Внешний ID",
      "offer": "Предложение",
      "user": "Клиент",
      "price": "Цена",
      "progress": "Использование",
      "source": "Источник",
      "status": "Статус",
      "purchaseDate": "Дата покупки",
      "actions": "Действия"
    },
    "labels": {
      "validUntil": "Действителен до",
      "remaining": "осталось",
      "usedAt": "Использован",
      "cancelledAt": "Отменен"
    },
    "buttons": {
      "cancel": "Отменить покупку"
    },
    "paymentTypes": {
      "cash": "Наличные",
      "card": "Карта",
      "transfer": "Перевод"
    },
    "cancelModal": {
      "title": "Отмена покупки",
      "operationType": "Тип операции",
      "withoutRefund": "Отмена без возврата",
      "withRefund": "Отмена с возвратом",
      "refundAmount": "Сумма возврата",
      "paymentType": "Тип оплаты",
      "confirm": "Подтвердить отмену"
    },
    "messages": {
      "cancelled": "Покупка успешно отменена",
      "cancelError": "Не удалось отменить покупку"
    }
  },
  "offerAnalytics": {
    "title": "Аналитика предложений",
    "filters": {
      "branch": "Филиал",
      "startDate": "Дата начала",
      "endDate": "Дата окончания"
    },
    "summary": {
      "totalRevenue": "Общий доход",
      "totalSold": "Всего продано",
      "commission": "Комиссия",
      "totalPurchases": "Всего покупок"
    },
    "charts": {
      "dailyRevenue": "Ежедневный доход",
      "revenueByOffer": "Доход по предложениям",
      "categoryRevenue": "Доход по категориям",
      "statusDistribution": "Распределение по статусам",
      "sourceDistribution": "Распределение по источникам",
      "revenueTable": "Детали дохода"
    },
    "columns": {
      "offer": "Предложение",
      "quantity": "Количество",
      "revenue": "Доход",
      "status": "Статус",
      "count": "Количество",
      "percentage": "Процент",
      "source": "Источник",
      "category": "Категория"
    },
    "labels": {
      "total": "Итого",
      "offer": "Предложение",
      "revenue": "Доход",
      "category": "Категория",
      "commission": "Комиссия"
    },
    "status": {
      "active": "Активный",
      "used": "Использован",
      "cancelled": "Отменен"
    },
    "sources": {
      "onlineBookings": "Онлайн бронирования",
      "bookinghub": "BookingHub",
      "swoop": "Swoop"
    },
    "empty": {
      "noData": "Нет данных за выбранный период"
    }
  },
  "offerView": {
    "stats": {
      "price": "Цена",
      "sold": "Продано",
      "remaining": "Осталось",
      "services": "Услуги"
    },
    "sections": {
      "images": "Изображения",
      "services": "Включенные услуги",
      "onlineServices": "Онлайн-услуги",
      "translations": "Переводы",
      "details": "Детали",
      "dates": "Даты",
      "platforms": "Платформы",
      "branches": "Доступные филиалы",
      "purchaseStats": "Статистика покупок",
      "packageSettings": "Настройки пакета"
    },
    "columns": {
      "service": "Услуга",
      "quantity": "Кол-во",
      "originalPrice": "Начальная цена",
      "discountedPrice": "Цена со скидкой",
      "employees": "Сотрудники"
    },
    "fields": {
      "id": "ID",
      "category": "Категория",
      "offerType": "Тип предложения",
      "status": "Статус",
      "notifyMerchant": "Уведомить о продаже",
      "bookingHubCategory": "Категория BookingHub",
      "salePeriod": "Период продажи",
      "validityPeriod": "Период действия",
      "createdAt": "Создано",
      "frontName": "Публичное название",
      "name": "Внутреннее название",
      "description": "Описание",
      "activationMethod": "Метод активации",
      "activeDays": "Активных дней",
      "allowInternalSale": "Внутренняя продажа"
    },
    "languages": {
      "ka": "Грузинский",
      "en": "Английский",
      "ru": "Русский"
    },
    "labels": {
      "total": "Итого"
    },
    "published": "Опубликовано",
    "notPublished": "Не опубликовано",
    "empty": {
      "noImages": "Изображения не загружены",
      "noServices": "Услуги не добавлены",
      "noTranslation": "Перевод недоступен",
      "notFound": "Предложение не найдено"
    },
    "purchaseStats": {
      "totalRevenue": "Общий доход",
      "totalPurchases": "Покупки",
      "commission": "Комиссия",
      "commissionPercent": "Комиссия %",
      "statusDistribution": "Распределение по статусам",
      "sourceDistribution": "Распределение по источникам",
      "status": "Статус",
      "source": "Источник",
      "count": "Количество",
      "revenue": "Доход",
      "noData": "Данные о покупках отсутствуют",
      "statuses": {
        "active": "Активный",
        "used": "Использован",
        "cancelled": "Отменён"
      }
    }
  },
  "validation": {
    "required": "Это поле обязательно для заполнения"
  },
  "dashboard": {
    "title": "Панель управления",
    "totalRevenue": "Общий доход",
    "todayRevenue": "Доход за сегодня",
    "services": "Услуги",
    "products": "Продукция",
    "averageTicket": "Средний чек",
    "bookings": "Бронирования",
    "totalBookings": "Всего бронирований",
    "completedBookings": "Завершено",
    "canceledBookings": "Отменено",
    "noShowBookings": "Не явился",
    "pendingBookings": "Ожидает",
    "inProgressBookings": "В процессе",
    "occupancy": "Загруженность",
    "employeeOccupancy": "Сотрудники",
    "roomOccupancy": "Кабинеты",
    "combinedOccupancy": "Общая",
    "today": "Сегодня",
    "week": "Неделя",
    "month": "Месяц",
    "availableSlots": "Свободное время",
    "todaySlots": "Сегодня",
    "tomorrowSlots": "Завтра",
    "noAvailableSlots": "Нет свободного времени",
    "minutes": "мин",
    "clientStats": "Статистика клиентов",
    "topVisitors": "Топ посетителей",
    "topSpenders": "Топ по расходам",
    "newClients": "Новые клиенты",
    "returningClients": "Вернувшиеся клиенты",
    "clientName": "Клиент",
    "visitCount": "Визиты",
    "totalSpent": "Потрачено",
    "revenue": "Доход",
    "count": "Количество"
  },
  "ehr": {
    "successfullySaved": "Успешно сохранено",
    "saveFailed": "Ошибка сохранения",
    "errorSending": "Ошибка отправки в ЭМК",
    "successfullySent": "Успешно отправлено в ЭМК",
    "ambulatoryCard": {
      "title": "Амбулаторная карта визита",
      "subtitle": "Малая карта | Амбулаторная карта",
      "copyEpisodeData": "Копировать данные из другого эпизода",
      "copyEpisodeModal": {
        "title": "Копировать данные из другого эпизода",
        "selectEpisode": "Выберите эпизод",
        "chooseSections": "Выберите данные для копирования",
        "noEpisodes": "У этого пациента нет других эпизодов",
        "copyButton": "Копировать",
        "backButton": "Назад",
        "cancelButton": "Отмена",
        "copiedToast": "Данные скопированы. Проверьте и нажмите Сохранить.",
        "loadError": "Не удалось загрузить эпизод",
        "columns": {
          "date": "Дата",
          "ehrNo": "Номер карты",
          "doctor": "Врач"
        },
        "sections": {
          "diagnoses": "Диагнозы",
          "narrative": "Клиническое описание",
          "recommendations": "Рекомендации",
          "prescriptions": "Назначения (eRx)",
          "insurance": "Страхование / Работа"
        }
      },
      "printForm100": "Печать формы 100",
      "printPrescription": "Печать назначения",
      "printInformedConsent": "Печать информированного согласия",
      "smsVerification": "СМС верификация",
      "uploadDocument": "Загрузить документ",
      "actions": "Действия",
      "comingSoon": "Скоро будет добавлено",
      "noPrescriptions": "Назначения не заполнены",
      "noInformedConsent": "Информированное согласие не заполнено",
      "savingInProgress": "Идёт сохранение формы...",
      "validationError": "Пожалуйста, заполните обязательные поля",
      "characters": "символов",
      "personalNumberLength": "Личный номер должен содержать 11 символов",
      "requiredField": "Обязательное поле",
      "sendToEhr": "Отправить",
      "save": "Сохранить",
      "whereSent": "Куда направляется справка",
      "form100Number": "Номер формы 100",
      "lastName": "Фамилия",
      "firstName": "Имя",
      "fatherName": "Отчество",
      "episodeNumber": "Номер эпизода",
      "gender": "Пол",
      "birthDateAge": "Дата рождения / Возраст",
      "maritalStatus": "Семейное положение",
      "disabilityStatus": "Статус инвалидности",
      "personalNumber": "Личный номер",
      "country": "Страна",
      "selectCountry": "Выберите страну",
      "city": "Город",
      "selectCity": "Выберите город",
      "placeOfResidence": "Место проживания",
      "cityDistrict": "Город / Район",
      "address": "Адрес",
      "phone": "Телефон",
      "employmentStatus": "Статус занятости",
      "education": "Образование",
      "workplaceProfession": "Место работы, профессия, должность",
      "insuranceCompany": "Страховая компания",
      "fundingSources": "Источники финансирования",
      "caseNumber": "Номер случая / номер кармана",
      "patientAdmissionDate": "Дата и время поступления пациента",
      "ambulatoryReferral": "а) Амбулаторное направление",
      "episodeEndDate": "Дата и время окончания эпизода",
      "bloodGroupRh": "Группа крови / Rh-фактор",
      "ehrConsent": "Даю согласие на скрытие/публикацию данных на портале EHR",
      "visibilityStatus": "Статус скрытия/публикации",
      "section9": "9. Заключение о состоянии здоровья или полный диагноз (основное заболевание, сопутствующие заболевания, осложнения)",
      "diagnosisFirstTime": "Диагноз поставлен впервые в жизни",
      "pleaseSelect": "Пожалуйста, выберите",
      "primaryDiseaseIcd": "Основное заболевание / МКБ /",
      "selectIcdCode": "Выберите код МКБ",
      "diagnosisDate": "Дата диагноза",
      "character": "Характер",
      "doctorClarification": "Уточнение врача",
      "complicationsIcd": "Осложнения основного заболевания / МКБ /",
      "icdCode": "Код МКБ",
      "clarification": "Уточнение",
      "accompanyingDiseaseIcd": "Сопутствующее заболевание / МКБ /",
      "section10_11": "10. Перенесённые заболевания",
      "section10_11_sub": "11. Краткий анамнез",
      "complaintsIcpc": "Жалобы / ICPC /",
      "patientComplainsIcpc": "Жалобы пациента / ICPC /",
      "complaintName": "Название жалобы",
      "year": "Год",
      "complaints": "Жалобы",
      "anamnesis": "Анамнез",
      "pastDiseases": "Перенесённые заболевания",
      "pregnancyCount": "Количество беременностей",
      "deliveryCount": "Количество родов",
      "fillData": "Заполните данные",
      "addService": "Добавить услугу",
      "section12": "12. Проведённые диагностические исследования и консультации",
      "comment": "Комментарий",
      "unspecified": "Неопределённо",
      "clinicalDiagnosticStudies": "Клинико-диагностические исследования",
      "labStudies": "Лабораторные исследования",
      "surgeries": "Хирургические вмешательства",
      "consultations": "Консультации",
      "otherActivity": "Прочая активность",
      "transfusion": "Трансфузия",
      "anesthesia": "Анестезия",
      "operationProtocol": "Протокол операции",
      "prescriptionTreatment": "Назначенное лечение",
      "bloodComponent": "Компонент крови",
      "protocolNo": "Номер протокола",
      "protocolText": "Текст протокола",
      "drug": "Препарат",
      "dosage": "Дозировка",
      "laboratory": "Лаборатория",
      "text": "Текст",
      "consultationsTable": "Консультации",
      "specialty": "Специальность",
      "doctor": "Врач",
      "deleteConfirm": "Удалить?",
      "section13": "13. Течение заболевания",
      "episodeType": "Тип эпизода",
      "episodeResult": "Результат эпизода",
      "section14": "14. Проведённое лечение",
      "conditionAtReferral": "15. Состояние при направлении",
      "selectCondition": "Выберите состояние",
      "conditionAtDischarge": "16. Состояние при выписке",
      "section17": "17. Рекомендации / назначения",
      "instrumentalStudiesNcsp": "Инструментальные исследования / NCSP /",
      "ncspCode": "Код NCSP",
      "date": "Дата",
      "labStudiesLab": "Лабораторные исследования / LAB /",
      "labCode": "Лабораторный код",
      "consultationsAmbulatory": "Амбулаторные консультации",
      "specialtyField": "Специальность",
      "deadline": "Срок",
      "otherRecommendations": "Другие рекомендации",
      "adviceInstruction": "Совет / рекомендация",
      "prescription": "Назначение",
      "uploadToPortal": "Загрузить на портал",
      "sent": "Отправлено",
      "notSent": "Не отправлено",
      "error": "Ошибка",
      "sending": "Отправляется...",
      "sendToPortal": "Отправить на портал",
      "prescriptionSent": "Рецепт отправлен на портал",
      "prescriptionCancelled": "Рецепт отменён на портале",
      "cancelFailed": "Не удалось отменить на портале",
      "savePrescriptionFirst": "Сначала сохраните рецепт",
      "addPrescriptionTooltip": "Добавить рецепт",
      "searchMedicineTooltip": "Найти лекарство",
      "sendToPortalTooltip": "Отправить рецепт на портал э-рецептов",
      "deletePrescriptionTooltip": "Удалить рецепт",
      "medicine": "Медикамент",
      "search": "Поиск",
      "tradeForm": "Торговая форма",
      "quantity": "Количество",
      "usageRule": "Правила приёма",
      "prescriptionValidity": "Срок",
      "prescriptionRecommendation": "Назначение / рекомендация",
      "attendingDoctor": "Лечащий врач (имя)",
      "selectDoctor": "Выберите врача",
      "create": "Создать",
      "maritalStatusOptions": {
        "married": "В браке",
        "cohabiting": "Сожительство",
        "single": "Не в браке",
        "divorced": "Разведён(а)",
        "widowed": "Вдовец/вдова"
      },
      "disabilityOptions": {
        "none": "Не выражена",
        "severe": "Резко выражена",
        "significant": "Значительно выражена",
        "moderate": "Умеренно выражена"
      },
      "countryOptions": {
        "georgia": "Грузия",
        "other": "Другая"
      },
      "residenceOptions": {
        "city": "Город / Район",
        "village": "Село"
      },
      "cityOptions": {
        "tbilisi": "Тбилиси",
        "kutaisi": "Кутаиси",
        "batumi": "Батуми"
      },
      "employmentOptions": {
        "employed": "Работающий",
        "unemployed": "Безработный",
        "student": "Студент / Учащийся",
        "retired": "Пенсионер",
        "disabled": "Лицо с ОВЗ",
        "minor": "Несовершеннолетний",
        "military": "Военнослужащий",
        "other": "Другое"
      },
      "educationOptions": {
        "unknown": "Неизвестно",
        "primary": "Начальное",
        "secondary": "Среднее",
        "higher": "Высшее",
        "vocational": "Профессиональное"
      },
      "fundingOptions": {
        "self": "Самофинансирование",
        "universal": "Всеобщее здравоохранение",
        "private": "Частное страхование"
      },
      "yesNoOptions": {
        "yes": "Да",
        "no": "Нет",
        "unknown": "Неизвестно"
      },
      "isGenericOptions": {
        "onlyGeneric": "Только дженерик",
        "genericAndTrade": "Дженерик и торговый",
        "onlyTrade": "Только торговый"
      }
    },
    "patients": {
      "status": "Статус",
      "bookingDate": "Дата записи",
      "user": "Пользователь",
      "mobile": "Мобильный",
      "employee": "Сотрудник",
      "startTime": "Время начала",
      "endTime": "Время окончания",
      "service": "Услуга",
      "room": "Комната",
      "personalNumber": "Личный номер",
      "view": "Просмотр",
      "ambulatoryCard": "Амбулаторная карта",
      "smallAmbulatoryCard": "Малая амбулаторная карта"
    },
    "confirmSend": "Вы уверены, что хотите отправить?"
  },
  "visitComments": {
    "tabTitle": "Комментарии",
    "noComments": "Комментариев нет",
    "placeholder": "Напишите комментарий...",
    "selectBooking": "Привязать к бронированию",
    "selectService": "Привязать к услуге",
    "fromDescription": "Из описания",
    "deleteConfirm": "Удалить комментарий?",
    "commentsLabel": "комментариев",
    "pinned": "Закреплено",
    "pin": "Закрепить",
    "unpin": "Открепить"
  },
  "templateEditor": {
    "insertField": "Вставить поле",
    "text": "Текст",
    "checkbox": "Флажок",
    "select": "Выбор",
    "apiSelect": "API Выбор",
    "signature": "Подпись",
    "table": "Таблица",
    "backToList": "Назад к списку",
    "templateName": "Название шаблона",
    "importDocx": "Импорт файла .docx",
    "importWord": "Импорт Word",
    "save": "Сохранить",
    "previewTooltip": "Предпросмотр и заполнение шаблона",
    "fillPreview": "Заполнить / Предпросмотр",
    "date": "Дата",
    "number": "Число",
    "textarea": "Текстовая область",
    "image": "Изображение",
    "calculated": "Вычисление",
    "autoFill": "Авто-заполнение",
    "tooltips": {
      "text": "Вставить текстовое поле",
      "checkbox": "Вставить флажок",
      "select": "Вставить раскрывающийся список со статическими вариантами",
      "apiSelect": "Вставить раскрывающийся список с вариантами из API",
      "signature": "Вставить поле для подписи",
      "table": "Вставить динамическую таблицу",
      "date": "Вставить поле выбора даты",
      "number": "Вставить числовое поле",
      "textarea": "Вставить многострочное текстовое поле",
      "image": "Вставить поле загрузки изображения",
      "calculated": "Вставить вычисляемое поле",
      "autoFill": "Вставить поле авто-заполнения (пациент, врач, дата)"
    }
  },
  "servicePackages": {
    "title": "Сервисные пакеты",
    "active": "Активный",
    "inactive": "Неактивный",
    "days": "дн.",
    "servicesCount": "услуг",
    "columns": {
      "name": "Название",
      "price": "Цена",
      "validity": "Срок действия",
      "services": "Услуги",
      "status": "Статус",
      "actions": "Действия"
    },
    "buttons": {
      "purchases": "Покупки",
      "create": "Создать",
      "sell": "Продать",
      "cancel": "Отменить",
      "details": "Подробнее"
    },
    "filters": {
      "search": "Поиск...",
      "status": "Статус",
      "all": "Все",
      "receivedGifts": "Полученные подарки",
      "givenGifts": "Подаренные",
      "ownPurchases": "Свои покупки"
    },
    "status": {
      "ACTIVE": "Активный",
      "USED": "Использован",
      "CANCELLED": "Отменён",
      "EXPIRED": "Истёк"
    },
    "lifecycle": {
      "new": "Новый",
      "partiallyUsed": "Частично использован",
      "fullyUsed": "Полностью использован",
      "cancelled": "Отменён",
      "expired": "Истёк"
    },
    "form": {
      "createTitle": "Создание пакета",
      "editTitle": "Редактирование пакета",
      "basicInfo": "Основная информация",
      "name": "Название",
      "namePlaceholder": "Название пакета",
      "price": "Цена",
      "validityDays": "Срок действия (дни)",
      "isActive": "Активный",
      "description": "Описание",
      "descriptionPlaceholder": "Описание пакета",
      "servicesTitle": "Входящие услуги",
      "addService": "Добавить услугу",
      "noServices": "Услуги не добавлены",
      "selectService": "Выберите услугу",
      "quantity": "Количество",
      "originalPrice": "Оригинальная цена",
      "discountPercent": "Скидка %",
      "discountedPrice": "Цена со скидкой",
      "totalOriginal": "Итого без скидки",
      "discount": "Скидка",
      "packageTotal": "Цена пакета",
      "itemsSum": "Сумма услуг",
      "useItemsSum": "Вернуть сумму услуг",
      "serviceName": "Название услуги"
    },
    "view": {
      "title": "Детали пакета",
      "details": "Детали",
      "includedServices": "Входящие услуги",
      "subtotal": "Промежуточный итог",
      "recentPurchases": "Последние покупки"
    },
    "purchases": {
      "title": "История покупок",
      "package": "Пакет",
      "customer": "Клиент",
      "owner": "Владелец",
      "status": "Статус",
      "lifecycle": "Жизненный цикл",
      "usage": "Использование",
      "price": "Цена",
      "validUntil": "Действует до",
      "empty": "Покупки не найдены",
      "filterStatus": "Фильтр по статусу",
      "filterPackage": "Фильтр по пакету",
      "filterCustomer": "Фильтр по клиенту",
      "searchPlaceholder": "Поиск по имени или телефону",
      "emptyFiltered": "Нет покупок по заданным фильтрам",
      "emptyNone": "Покупок пока нет",
      "editedBadge": "Изменено",
      "giftFrom": "Подарок от",
      "giftTo": "Подарено"
    },
    "sellModal": {
      "title": "Продажа пакета",
      "customer": "Клиент",
      "searchCustomer": "Поиск клиента...",
      "paymentMethod": "Способ оплаты",
      "paidAmount": "Оплаченная сумма",
      "comment": "Комментарий",
      "commentPlaceholder": "Комментарий (необязательно)",
      "paymentSumMismatch": "Сумма оплаты должна совпадать с ценой пакета"
    },
    "confirm": {
      "delete": "Вы уверены, что хотите удалить этот пакет?",
      "cancel": "Вы уверены, что хотите отменить эту покупку?",
      "cancelDescription": "После отмены клиент больше не сможет использовать оставшиеся услуги."
    },
    "messages": {
      "loadError": "Не удалось загрузить пакет",
      "created": "Пакет успешно создан",
      "createError": "Не удалось создать пакет",
      "updated": "Пакет успешно обновлён",
      "updateError": "Не удалось обновить пакет",
      "deleted": "Пакет успешно удалён",
      "deleteError": "Не удалось удалить пакет",
      "sold": "Пакет успешно продан",
      "sellError": "Не удалось продать пакет",
      "cancelled": "Покупка отменена",
      "cancelError": "Не удалось отменить покупку",
      "editError": "Не удалось отредактировать покупку",
      "refunded": "Возврат выполнен"
    },
    "editModal": {
      "reason": "Причина редактирования",
      "reasonText": "Текст причины",
      "balanceChange": "Изменение баланса",
      "amountToCollect": "Сумма к оплате",
      "fullHistory": "Полная история",
      "priceRoleDisabled": "Изменять цену может только администратор или менеджер",
      "futureBookingConflictTitle": "Конфликт с будущими записями",
      "futureBookingConflictBookings": "Записи",
      "futureBookingConflictConfirm": "Всё равно сохранить",
      "displayName": "Отображаемое имя",
      "validUntil": "Действует до",
      "comment": "Комментарий",
      "items": "Услуги",
      "service": "Услуга",
      "quantity": "Количество",
      "consumed": "Использовано",
      "addItem": "Добавить услугу",
      "added": "Услуга добавлена",
      "removed": "Услуга удалена",
      "history": "История редактирования",
      "noHistory": "История редактирования отсутствует",
      "originalPrice": "Исходная цена",
      "discountedPrice": "Цена со скидкой",
      "settlementBalance": "Баланс",
      "settlementCash": "Касса",
      "settlementNone": "Без финансовой операции",
      "chargeCollect": "Оплата",
      "refundLabel": "Возврат",
      "customer": "Клиент",
      "customerBalance": "Текущий баланс",
      "settlementCommentPlaceholder": "Комментарий к возврату / оплате",
      "saleDate": "Дата продажи",
      "soldBy": "Продавец",
      "validity": "Срок действия",
      "totalPaid": "Оплачено",
      "payment": "Оплата",
      "payCash": "Наличные",
      "payCard": "Карта",
      "payBalance": "Баланс",
      "payBank": "Перевод",
      "payConsignation": "Консигнация",
      "remaining": "Остаток",
      "totalServices": "Услуги",
      "totalQuantity": "Всего количество",
      "totalOriginal": "Сумма (ориг.)",
      "totalDiscounted": "Сумма (со скидкой)"
    },
    "history": {
      "title": "История пакета",
      "when": "Дата",
      "kind": "Тип",
      "who": "Кто",
      "details": "Детали",
      "usage": "Использование",
      "kinds": {
        "audit": "Изменение",
        "adjustment": "Корректировка",
        "usage": "Использование"
      }
    },
    "refund": {
      "used": "Использовано",
      "typeLabel": "Тип возврата",
      "type": {
        "full": "Вернуть полную сумму",
        "remaining": "Вернуть остаточную стоимость"
      },
      "methodLabel": "Способ возврата",
      "method": {
        "balance": "На баланс клиента",
        "none": "Без финансовой операции",
        "cashbox": "Из кассы"
      },
      "commentLabel": "Причина (необязательно)",
      "commentPlaceholder": "Укажите причину возврата",
      "fullyUsed": "Полностью использованный пакет нельзя отменить",
      "refundable": "Возвращаемая стоимость",
      "moneyBack": "Сумма к возврату",
      "voidedDebt": "Списанный долг",
      "confirm": "Подтвердить возврат",
      "settlementLabel": "Провести возврат",
      "settlement": {
        "today": "По сегодняшней кассе",
        "saleDate": "По кассе дня продажи"
      },
      "settlementHint": "Выберите, из кассы какого дня уходят деньги. Если та касса уже закрыта, она будет пересчитана."
    }
  },
  "nps": {
    "title": "Оценка",
    "question": "Оцените от 0 до 10, насколько вероятно, что вы порекомендуете наш сервис другу?",
    "notLikely": "Маловероятно",
    "veryLikely": "Очень вероятно",
    "commentPlaceholder": "Оставьте комментарий (необязательно)",
    "submit": "Отправить",
    "thankYou": "Спасибо за вашу оценку!",
    "error": "Не удалось отправить оценку, попробуйте снова"
  },
  "EVENT_DESC": {
    "BOOKED": "Клиент получает подтверждение записи.",
    "COMPLETED": "Клиент получает сообщение после визита.",
    "BOOKING_UPDATE": "Клиент узнаёт, что запись изменилась.",
    "BOOKING_DELETED": "Клиент узнаёт об отмене записи.",
    "BOOKING_REMINDER": "Клиент получает напоминание перед визитом.",
    "PERIODIC_REMINDER": "Бывший клиент получает напоминание записаться снова.",
    "ONLINE_BOOKING_INCOME": "Клиент получает подтверждение онлайн-записи.",
    "ONLINE_BOOKING_CANCEL": "Клиент узнаёт об отмене онлайн-записи.",
    "VERIFICATION_SMS": "Клиент получает код и ссылку для подтверждения.",
    "OFFER_EXPIRY_WARNING": "Покупатель узнаёт, что срок ваучера заканчивается.",
    "OFFER_PURCHASE_CONFIRMATION": "Покупатель получает подтверждение покупки ваучера.",
    "OFFER_MERCHANT_NOTIFICATION": "Ваша команда узнаёт о продаже ваучера.",
    "PACKAGE_PURCHASE_CONFIRMATION": "Покупатель получает подтверждение покупки пакета.",
    "PACKAGE_USAGE": "Покупатель узнаёт, что использована одна услуга из пакета.",
    "PACKAGE_BATCH_USAGE": "Покупатель узнаёт, что за визит использовано несколько услуг.",
    "PACKAGE_EXPIRED": "Покупатель узнаёт, что срок пакета истёк.",
    "PACKAGE_EXPIRY_WARNING": "Покупатель узнаёт, что срок пакета заканчивается.",
    "INVOICE_GENERATED": "Салон получает сообщение о создании счёта.",
    "EMPLOYEE_PASSWORD_RESET": "Сотрудник получает новые данные для входа.",
    "USER_PASSWORD_RESET": "Пользователь получает новые данные для входа."
  },
  "KEYWORD": {
    "code": "Код",
    "customerName": "Имя клиента",
    "date": "Дата",
    "daysBeforeExpiry": "Дней до истечения",
    "expiryDate": "Дата истечения",
    "firstName": "Имя",
    "invoiceId": "Номер счёта",
    "link": "Ссылка",
    "offerName": "Название ваучера",
    "organizationName": "Организация",
    "packageName": "Название пакета",
    "password": "Пароль",
    "positionName": "Специалист",
    "price": "Цена",
    "remaining": "Осталось услуг",
    "serviceName": "Услуга",
    "serviceNames": "Услуги",
    "source": "Источник",
    "time": "Время",
    "totalPrice": "Сумма",
    "username": "Логин",
    "validFrom": "Действует с",
    "validTo": "Действует до",
    "validUntil": "Действует до"
  },
  "warehouse": {
    "products": {
      "addProduct/edit": "Добавление/редактирование продукта",
      "updateHistory": "История обновлений",
      "updateProduct": "Обновление продукта",
      "stockAccounting": "Учет запасов",
      "addProvider/edit": "Добавить/отредактировать поставщика",
      "addEditCategory": "Добавить/отредактировать категорию",
      "barcodeAlready": "Штрих-код уже существует в базе данных",
      "title": "Продукты",
      "column": {
        "barcode": "Штрих-код",
        "productCode": "Код продукта",
        "title": "Название",
        "category": "Категория",
        "provider": "Поставщик",
        "quantity": "Количество",
        "grammInEach": "Граммов в каждом",
        "receivingPrice": "Цена получения",
        "admissionPrice(average)": "Приемлемая цена (средняя)",
        "salePrice": "Цена продажи",
        "sumTotal": "Общая сумма",
        "sumTotal(gram)": "Общая сумма (грамм)",
        "dateOfPurchase": "Дата покупки",
        "validUntil": "Действителен до",
        "dateOfUpdate": "Дата обновления",
        "createdBy": "Созданный",
        "comment": "Комментарий",
        "stockAccounting": "Учет запасов",
        "currentBalance": "Текущий баланс",
        "changeInStock": "Изменение запасов",
        "created": "Созданный",
        "legalForm": "Правовая форма",
        "identification": "# Для идентификации",
        "phoneNumber": "Номер телефона",
        "information": "Информация"
      },
      "form": {
        "barcode": "Штрих-код",
        "productCode": "Код продукта",
        "title": "Название",
        "category": "Категория",
        "provider": "Поставщик",
        "quantity": "Количество",
        "grammInEach": "Граммов в каждом",
        "receivingPrice": "Цена получения",
        "admissionPrice(average)": "Приемлемая цена (средняя)",
        "salePrice": "Цена продажи",
        "sumTotal": "Общая сумма",
        "Balance(grams)": "Остаток (граммы)",
        "dateOfPurchase": "Дата покупки",
        "validUntil": "Действителен до",
        "comment": "Комментарий",
        "averagePrice": "средняя цена",
        "expenseProcessing": "Обработка расхода",
        "selectDate": "Выберите дату",
        "accountingDate": "Отчетная дата",
        "responsiblePerson": "Ответственное лицо",
        "gram": "Грамм",
        "productCategory": "Категория продукта",
        "legalForm": "Правовая форма",
        "identification": "# Для идентификации",
        "phoneNumber": "Номер телефона",
        "information": "Информация"
      }
    },
    "categories": {
      "title": "Категории"
    },
    "Providers": {
      "title": "Поставщики"
    },
    "list": {
      "title": "Склады",
      "create": "Создать склад"
    },
    "columns": {
      "name": "Название",
      "type": "Тип",
      "address": "Адрес",
      "status": "Статус",
      "actions": "Действия"
    },
    "types": {
      "MAIN": "Основной",
      "SECONDARY": "Вторичный",
      "TRANSIT": "Транзитный"
    },
    "default": "По умолчанию",
    "active": "Активный",
    "inactive": "Неактивный",
    "setDefault": "Установить по умолчанию",
    "confirm": {
      "delete": "Вы уверены, что хотите удалить этот склад?"
    },
    "messages": {
      "setDefault": "Склад установлен по умолчанию",
      "setDefaultError": "Не удалось установить склад по умолчанию",
      "deleted": "Склад удалён",
      "deleteError": "Не удалось удалить склад",
      "loadError": "Не удалось загрузить склад",
      "created": "Склад успешно создан",
      "createError": "Не удалось создать склад",
      "updated": "Склад успешно обновлён",
      "updateError": "Не удалось обновить склад"
    },
    "form": {
      "createTitle": "Создать склад",
      "editTitle": "Редактировать склад",
      "basicInfo": "Основная информация",
      "name": "Название",
      "namePlaceholder": "Название склада",
      "type": "Тип",
      "typePlaceholder": "Выберите тип",
      "address": "Адрес",
      "addressPlaceholder": "Адрес склада",
      "description": "Описание",
      "descriptionPlaceholder": "Описание склада",
      "isDefault": "Склад по умолчанию",
      "isActive": "Активный"
    },
    "tabs": {
      "stock": "Запасы",
      "movements": "Движение"
    },
    "stock": {
      "title": "Запасы",
      "selectWarehouse": "Выберите склад",
      "product": "Продукт",
      "category": "Категория",
      "distributor": "Поставщик",
      "quantity": "Количество",
      "grAmount": "Граммы",
      "avgCost": "Ср. себестоимость",
      "sellPrice": "Цена продажи",
      "totalValue": "Общая стоимость",
      "search": "Поиск продуктов...",
      "viewMovements": "Просмотр движения",
      "lowStock": "Низкий запас"
    },
    "movements": {
      "date": "Дата",
      "product": "Продукт",
      "type": "Тип",
      "quantity": "Количество",
      "balance": "Остаток",
      "notes": "Заметки"
    },
    "movementTypes": {
      "RECEIVING": "Приём",
      "SALE_DEDUCTION": "Продажа",
      "SALE_RETURN": "Возврат продажи",
      "TRANSFER_OUT": "Перемещение (исх.)",
      "TRANSFER_IN": "Перемещение (вх.)",
      "ADJUSTMENT": "Корректировка",
      "SERVICE_CONSUMPTION": "Расход услуги",
      "SERVICE_RETURN": "Возврат услуги",
      "COUNT_CORRECTION": "Инвентаризация",
      "WRITE_OFF": "Списание",
      "SUPPLIER_RETURN": "Возврат поставщику",
      "INITIAL_MIGRATION": "Начальная миграция"
    },
    "adjustment": {
      "title": "Корректировка запасов",
      "type": "Тип корректировки",
      "newQuantity": "Новое количество",
      "newGrAmount": "Новые граммы",
      "reason": "Причина",
      "reasonPlaceholder": "Причина корректировки"
    }
  },
  "realization": {
    "operationCompleted": "Операция завершена",
    "search": {
      "user": "Пользователь",
      "realizationType": "Тип реализации",
      "withBarcode": "Поиск по штрих-коду",
      "searchProduct": "Поиск продукта"
    },
    "form": {
      "card": "# Карты",
      "firstname": "Имя",
      "name": "Имя",
      "lastname": "Фамилия",
      "phoneNumber": "Номер телефона",
      "idNumber": "Идентификационный номер",
      "gender": "Пол",
      "female": "Женский",
      "male": "Мужской",
      "dateOfBirth": "Дата рождения",
      "chooseDate": "Выберите дату",
      "city": "город",
      "address": "Юридический адрес",
      "workingPlace": "Рабочее место"
    },
    "categoryDetail": {
      "provider": "Поставщик",
      "price": "Цена",
      "grammInEach": "Граммов в каждом",
      "quantity": "Количество",
      "gramsTotal": "грамм всего"
    },
    "category": "Категория",
    "sumTotal": "Общая сумма",
    "gel": "GEL",
    "quantity": "Количество",
    "piece": "Единицы",
    "gram": "Грамм",
    "paymentMethod": "Способ оплаты",
    "balance": "баланс",
    "available": "доступный",
    "cash": "Наличными ",
    "card": "Банковская карта",
    "exchange": "Обмен",
    "consignment": "консигнация",
    "pay": "Оплатить",
    "comment": "Комментарий",
    "specifyComment": "Укажите комментарий",
    "paymentWithCash": "Оплата наличными",
    "BankCard": "Банковская карта",
    "cashViaBank": "Наличными + через банк",
    "sell": "Продать",
    "spend": "Тратить",
    "productOutStock": "Продукта нет в наличии",
    "product": "Продукт",
    "createUser": "Создать пользователя",
    "price": "Цена",
    "discount": "% от скидки",
    "withDiscount": "Сo скидкой",
    "employee": "работник",
    "addEmployee/edit": "Добавление работника/редактировать",
    "percent": "процент",
    "salary": "Зарплата"
  },
  "schedule": {
    "vacationRange": "Отпуск (диапазон)",
    "vacationApply": "Добавить",
    "vacationConflict": "В диапазоне {{count}} конфликт(ов). Всё равно продолжить?",
    "vacationSaved": "Отпуск добавлен",
    "vacationPickRange": "Выберите период",
    "clearAll": "Очистить график",
    "clearConfirmTitle": "Вы уверены, что хотите полностью очистить рабочий график сотрудника?",
    "clearConfirmBody": "Весь рабочий график сотрудника будет удалён.",
    "clearWarnBookings": "Внимание: у сотрудника есть {{count}} записанных визитов, которые останутся без графика.",
    "cleared": "График очищен",
    "clearWhat": "Что очистить?",
    "clearFromToday": "Очищается с сегодняшнего дня (прошлое сохраняется)",
    "clearWillRemove": "Будет удалено записей: {{count}}",
    "leaveType": "Тип",
    "period": "Период",
    "conflictTitle": "В диапазоне обнаружены конфликты",
    "conflictBookings": "Записи",
    "conflictLeave": "Существующие нерабочие дни",
    "conflictProceed": "Продолжить всё равно?",
    "startDate": "Дата начала",
    "endDate": "Дата окончания",
    "applyOn": "Применить к дням",
    "workingHours": "Рабочие часы",
    "perDayHours": "Часы по дням (необязательно)",
    "addBreak": "Добавить перерыв",
    "breaksAllDays": "Перерывы (все дни)",
    "save": "Сохранить",
    "endAfterStart": "Конец должен быть позже начала",
    "statusLabel": "Статус",
    "statusRequired": "Статус обязателен",
    "weekday": {
      "0": "Вс",
      "1": "Пн",
      "2": "Вт",
      "3": "Ср",
      "4": "Чт",
      "5": "Пт",
      "6": "Сб"
    },
    "break": {
      "LUNCH": "Обед",
      "COFFEE": "Кофе",
      "PERSONAL": "Личное"
    },
    "createSchedule": "Создать график",
    "addVacation": "Добавить отпуск",
    "addDay": "Добавить день",
    "logs": "История",
    "cancel": "Отмена",
    "multiTitle": "График на несколько дней",
    "editDay": "Редактировать день",
    "auditTitle": "История изменений",
    "status": {
      "SCHEDULED": "Запланировано",
      "DAY_OFF": "Выходной",
      "SICK_LEAVE": "Больничный",
      "VACATION": "Отпуск"
    }
  },
  "scheduleOverview": {
    "title": "График сотрудников",
    "employee": "Сотрудник",
    "searchPlaceholder": "Поиск по имени",
    "positionAll": "Все должности",
    "today": "Сегодня",
    "oneMonth": "1 месяц",
    "nMonths": "{{count}} мес.",
    "unscheduledDivider": "Без графика",
    "unscheduledCount": "{{count}} сотрудников без графика",
    "rowActions": "Действия",
    "rowActionHours": "Рабочие часы (период)",
    "rowActionLeave": "Добавить отпуск",
    "rowActionClear": "Очистить график",
    "noEmployees": "Сотрудники не найдены",
    "error": "Не удалось загрузить график",
    "retry": "Повторить"
  },
  "procedures": {
    "hub": {
      "overview": "Обзор",
      "employees": "Сотрудники",
      "category": "Категория",
      "colour": "Цвет",
      "type": "Тип",
      "price": "Цена",
      "discountPrice": "Цена со скидкой",
      "duration": "Продолжительность",
      "vat": "НДС",
      "maxParallel": "Макс. параллельных записей",
      "onlineBooking": "Онлайн-запись",
      "boundEmployees": "Связанные сотрудники",
      "missingParameters": "Противоречивое условие зарплаты",
      "selectAll": "Выбрать всех",
      "percent": "%",
      "noParameters": "Параметры не заданы",
      "saved": "Сохранено",
      "saveFailed": "Не удалось сохранить",
      "fillAllFields": "Для выбранных сотрудников заполните цену, время и одно условие оплаты — процент или фиксированную, не оба.",
      "save": "Сохранить",
      "loadProcedureFailed": "Не удалось загрузить сведения о процедуре.",
      "loadEmployeesFailed": "Не удалось загрузить сотрудников.",
      "loadBindingsFailed": "Не удалось загрузить параметры сотрудников.",
      "noneSelected": "Выберите хотя бы одного сотрудника перед сохранением.",
      "futureBookings": "{{count}} предстоящих",
      "willUnbind": "Будет снято сотрудников: {{count}}",
      "confirmUnbindTitle": "Снятие сотрудников",
      "confirmUnbindOk": "Снять",
      "confirmUnbindCancel": "Отмена",
      "confirmUnbindNote": "Существующие записи не удаляются. Эта процедура больше не будет предлагаться для этих сотрудников в новых записях.",
      "fixedSalary": "Фиксированная",
      "searchEmployee": "Поиск сотрудника",
      "defaultsLegend": "Серым показаны значения по умолчанию. Нажмите, чтобы задать другое для этого сотрудника.",
      "useDefault": "Вернуть значение по умолчанию",
      "overrideHint": "Нажмите, чтобы задать другое значение для этого сотрудника",
      "addEmployee": "Добавить сотрудника",
      "noEmployeesYet": "На эту услугу пока никто не назначен.",
      "sharedParams": "Общие параметры",
      "applyToSelected": "Применить к выбранным",
      "sharedApplied": "Параметры применены к {{count}} сотрудникам",
      "addAll": "Добавить всех",
      "allAdded": "Добавлено сотрудников: {{count}}"
    }
  },
  "employee360": {
    "tab": "360",
    "loadFailed": "Не удалось загрузить данные",
    "retry": "Повторить",
    "scheduledDays": "Отработанные дни",
    "custom": {
      "from": "Начало",
      "to": "Конец"
    },
    "period": {
      "TODAY": "Сегодня",
      "YESTERDAY": "Вчера",
      "THIS_WEEK": "Текущая неделя",
      "LAST_WEEK": "Прошлая неделя",
      "THIS_MONTH": "Текущий месяц",
      "LAST_MONTH": "Прошлый месяц",
      "THIS_YEAR": "Текущий год",
      "CUSTOM": "Период"
    },
    "kpi": {
      "revenue": "Принесённая сумма",
      "cost": "Начисленная зарплата",
      "netProfit": "Прибыль",
      "margin": "Маржа прибыли",
      "serviceEarned": "Заработано на услугах",
      "productEarned": "Заработано на товарах",
      "salaryPaid": "Выплаченная зарплата",
      "revenuePerWorkedDay": "Средний доход за рабочий день"
    },
    "countUnit": {
      "visits": "Визиты",
      "bookings": "Записи",
      "services": "Услуги"
    },
    "counts": {
      "total": "Всего",
      "completed": "Завершённые",
      "upcoming": "К выполнению",
      "cancelled": "Отменённые",
      "noShow": "Не явился"
    },
    "hourlyLoad": "Загрузка по часам",
    "topServices": "Топ услуг",
    "topServicesColumns": {
      "name": "Название",
      "count": "Количество",
      "revenue": "Доход"
    },
    "noData": "Нет данных"
  },
  "visit": {
    "missing": {
      "customer": "Выберите клиента",
      "date": "Укажите дату",
      "startTime": "Укажите время начала",
      "endTime": "Укажите время окончания",
      "unknown": "Чтобы сохранить запись, заполните все обязательные поля"
    }
  }
}
